// lib/IcaoDecoder.ts
var IcaoDecoder = class {
  name;
  icao;
  constructor(icao) {
    this.name = "icao-decoder-typescript";
    this.icao = icao;
  }
  isMilitary() {
    let i = this.icao;
    return i.match(/^adf[7-9]/) || i.match(/^adf[a-f]/) || i.match(/^a(e|f)/) || i.match(/^0100(7|8)/) || i.match(/^0a4/) || i.match(/^33ff/) || i >= "350000" && i <= "37ffff" || i.match(/^3a(8|9|[a-f])/) || i.match(/^3b/) || i.match(/^3e(a|b)/) || i.match(/^3f([4-9]|[a-b])/) || i.match(/^4000[0-3]/) || i.match(/^43c/) || i.match(/^44[4-7]/) && i != "447ac7" || i.match(/^44f/) || i.match(/^457/) || i.match(/^45f4/) || i.match(/^468[0-3]/) || i.match(/^473c0/) || i.match(/^4781/) || i.match(/^480/) || i.match(/^48d8[0-7]/) || i.match(/^497c/) || i.match(/^49842/) || i.match(/^4b7/) || i.match(/^4b82/) || i.match(/^506f/) || i.match(/^70c07/) || i.match(/^7102[5-8]/) || i.match(/^7103[8-9]/) || i.match(/^738a/) || i.match(/^7c8([2-4]|8)/) || i >= "7c9000" && i <= "7cbfff" || i.match(/^7[d-f]/) || i.match(/^8002/) || i.match(/^c[2-3]/) || i.match(/^e4[0-1]/) || i.match(/^e806/);
  }
};

// lib/DateTimeUtils.ts
var DateTimeUtils = class {
  // Expects a four digit UTC time string (HHMM)
  static UTCToString(UTCString) {
    let utcDate = /* @__PURE__ */ new Date();
    utcDate.setUTCHours(+UTCString.substr(0, 2), +UTCString.substr(2, 2), 0);
    return utcDate.toTimeString();
  }
  // Expects a six digit date string and a four digit UTC time string
  // (DDMMYY) (HHMM)
  static UTCDateTimeToString(dateString, timeString) {
    let utcDate = /* @__PURE__ */ new Date();
    utcDate.setUTCDate(+dateString.substr(0, 2));
    utcDate.setUTCMonth(+dateString.substr(2, 2));
    if (dateString.length === 6) {
      utcDate.setUTCFullYear(2e3 + +dateString.substr(4, 2));
    }
    if (timeString.length === 6) {
      utcDate.setUTCHours(+timeString.substr(0, 2), +timeString.substr(2, 2), +timeString.substr(4, 2));
    } else {
      utcDate.setUTCHours(+timeString.substr(0, 2), +timeString.substr(2, 2), 0);
    }
    return utcDate.toUTCString();
  }
  /**
   * 
   * @param time HHMMSS or HHMM
   * @returns seconds since midnight
   */
  static convertHHMMSSToTod(time) {
    if (time.length === 4) {
      time += "00";
    }
    const h = Number(time.substring(0, 2));
    const m = Number(time.substring(2, 4));
    const s = Number(time.substring(4, 6));
    const tod = h * 3600 + m * 60 + s;
    return tod;
  }
  /**
   * 
   * @param time HHMMSS
   * @param date MMDDYY or MMDDYYYY
   * @returns seconds since epoch
   */
  static convertDateTimeToEpoch(time, date) {
    if (date.length === 6) {
      date = date.substring(0, 4) + `20${date.substring(4, 6)}`;
    }
    const timestamp = `${date.substring(4, 8)}-${date.substring(0, 2)}-${date.substring(2, 4)}T${time.substring(0, 2)}:${time.substring(2, 4)}:${time.substring(4, 6)}.000Z`;
    const millis = Date.parse(timestamp);
    return millis / 1e3;
  }
  /**
   * Converts a timestamp to a string
   * 
   * ISO-8601 format for 'epoch'
   * HH:MM:SS for 'tod'
   * @param time 
   * @param format 
   * @returns 
   */
  static timestampToString(time, format) {
    const date = new Date(time * 1e3);
    if (format == "tod") {
      return date.toISOString().slice(11, 19);
    }
    return date.toISOString().slice(0, -5) + "Z";
  }
};

// lib/DecoderPlugin.ts
var DecoderPlugin = class {
  decoder;
  name = "unknown";
  defaultResult() {
    return {
      decoded: false,
      decoder: {
        name: "unknown",
        type: "pattern-match",
        decodeLevel: "none"
      },
      formatted: {
        description: "Unknown",
        items: []
      },
      raw: {},
      remaining: {}
    };
  }
  options;
  constructor(decoder, options = {}) {
    this.decoder = decoder;
    this.options = options;
  }
  id() {
    console.log("DecoderPlugin subclass has not overriden id() to provide a unique ID for this plugin!");
    return "abstract_decoder_plugin";
  }
  meetsStateRequirements() {
    return true;
  }
  // onRegister(store: Store<any>) {
  //   this.store = store;
  // }
  qualifiers() {
    const labels = [];
    return {
      labels
    };
  }
  decode(message) {
    const decodeResult = this.defaultResult();
    decodeResult.remaining.text = message.text;
    return decodeResult;
  }
};

// lib/utils/coordinate_utils.ts
var CoordinateUtils = class _CoordinateUtils {
  /**
   * Decode a string of coordinates into an object with latitude and longitude in millidegrees
   * @param stringCoords - The string of coordinates to decode
   * 
   * @returns An object with latitude and longitude properties
   */
  static decodeStringCoordinates(stringCoords) {
    var results = {};
    const firstChar = stringCoords.substring(0, 1);
    let middleChar = stringCoords.substring(6, 7);
    let longitudeChars = stringCoords.substring(7, 13);
    if (middleChar == " ") {
      middleChar = stringCoords.substring(7, 8);
      longitudeChars = stringCoords.substring(8, 14);
    }
    if ((firstChar === "N" || firstChar === "S") && (middleChar === "W" || middleChar === "E")) {
      results.latitude = Number(stringCoords.substring(1, 6)) / 1e3 * _CoordinateUtils.getDirection(firstChar);
      results.longitude = Number(longitudeChars) / 1e3 * _CoordinateUtils.getDirection(middleChar);
    } else {
      return;
    }
    return results;
  }
  /**
  * Decode a string of coordinates into an object with latitude and longitude in degrees and decimal minutes
  * @param stringCoords - The string of coordinates to decode
  * 
  * @returns An object with latitude and longitude properties
  */
  static decodeStringCoordinatesDecimalMinutes(stringCoords) {
    var results = {};
    const firstChar = stringCoords.substring(0, 1);
    let middleChar = stringCoords.substring(6, 7);
    let longitudeChars = stringCoords.substring(7, 13);
    if (middleChar == " ") {
      middleChar = stringCoords.substring(7, 8);
      longitudeChars = stringCoords.substring(8, 14);
    }
    const latDeg = Math.trunc(Number(stringCoords.substring(1, 6)) / 1e3);
    const latMin = Number(stringCoords.substring(1, 6)) % 1e3 / 10;
    const lonDeg = Math.trunc(Number(longitudeChars) / 1e3);
    const lonMin = Number(longitudeChars) % 1e3 / 10;
    if ((firstChar === "N" || firstChar === "S") && (middleChar === "W" || middleChar === "E")) {
      results.latitude = (latDeg + latMin / 60) * _CoordinateUtils.getDirection(firstChar);
      results.longitude = (lonDeg + lonMin / 60) * _CoordinateUtils.getDirection(middleChar);
    } else {
      return;
    }
    return results;
  }
  static coordinateString(coords) {
    const latDir = coords.latitude > 0 ? "N" : "S";
    const lonDir = coords.longitude > 0 ? "E" : "W";
    return `${Math.abs(coords.latitude).toFixed(3)} ${latDir}, ${Math.abs(coords.longitude).toFixed(3)} ${lonDir}`;
  }
  static getDirection(coord) {
    if (coord.startsWith("N") || coord.startsWith("E")) {
      return 1;
    } else if (coord.startsWith("S") || coord.startsWith("W")) {
      return -1;
    }
    return NaN;
  }
  static dmsToDecimalDegrees(degrees, minutes, seconds) {
    return degrees + minutes / 60 + seconds / 3600;
  }
};

// lib/utils/route_utils.ts
var RouteUtils = class _RouteUtils {
  static formatFlightState(state) {
    switch (state) {
      case "TO":
        return "Takeoff";
      case "IC":
        return "Initial Climb";
      case "CL":
        return "Climb";
      case "ER":
        return "En Route";
      case "DC":
        return "Descent";
      case "AP":
        return "Approach";
      default:
        return `Unknown ${state}`;
    }
  }
  static routeToString(route) {
    let str = "";
    if (route.name) {
      str += route.name;
    }
    if (route.runway) {
      str += `(${route.runway})`;
    }
    if (str.length !== 0 && route.waypoints && route.waypoints.length === 1) {
      str += " starting at ";
    } else if (str.length !== 0 && route.waypoints) {
      str += ": ";
    }
    if (route.waypoints) {
      str += _RouteUtils.waypointsToString(route.waypoints);
    }
    return str;
  }
  static waypointToString(waypoint) {
    let s = waypoint.name;
    if (waypoint.latitude && waypoint.longitude) {
      s += `(${CoordinateUtils.coordinateString({ latitude: waypoint.latitude, longitude: waypoint.longitude })})`;
    }
    if (waypoint.offset) {
      s += `[${waypoint.offset.bearing}\xB0 ${waypoint.offset.distance}nm]`;
    }
    if (waypoint.time && waypoint.timeFormat) {
      s += `@${DateTimeUtils.timestampToString(waypoint.time, waypoint.timeFormat)}`;
    }
    return s;
  }
  static getWaypoint(leg) {
    const regex = leg.match(/^([A-Z]+)(\d{3})-(\d{4})$/);
    if (regex?.length == 4) {
      return { name: regex[1], offset: { bearing: parseInt(regex[2]), distance: parseInt(regex[3]) / 10 } };
    }
    const waypoint = leg.split(",");
    if (waypoint.length == 2) {
      const position = CoordinateUtils.decodeStringCoordinatesDecimalMinutes(waypoint[1]);
      if (position) {
        return { name: waypoint[0], latitude: position.latitude, longitude: position.longitude };
      }
    }
    if (leg.length == 13 || leg.length == 14) {
      const position = CoordinateUtils.decodeStringCoordinatesDecimalMinutes(leg);
      const name = waypoint.length == 2 ? waypoint[0] : "";
      if (position) {
        return { name, latitude: position.latitude, longitude: position.longitude };
      }
    }
    return { name: leg };
  }
  static waypointsToString(waypoints) {
    let str = waypoints.map((x) => _RouteUtils.waypointToString(x)).join(" > ").replaceAll(">  >", ">>");
    if (str.startsWith(" > ")) {
      str = ">>" + str.slice(2);
    }
    return str;
  }
};

// lib/utils/result_formatter.ts
var ResultFormatter = class {
  static route(decodeResult, route) {
    decodeResult.raw.route = route;
    decodeResult.formatted.items.push({
      type: "aircraft_route",
      code: "ROUTE",
      label: "Aircraft Route",
      value: RouteUtils.routeToString(route)
    });
  }
  static state_change(decodeResult, from, to) {
    decodeResult.raw.state_change = {
      from,
      to
    };
    from = RouteUtils.formatFlightState(from);
    to = RouteUtils.formatFlightState(to);
    decodeResult.formatted.items.push({
      type: "state_change",
      code: "STATE_CHANGE",
      label: "State Change",
      value: `${from} -> ${to}`
    });
  }
  static freetext(decodeResult, value) {
    decodeResult.raw.freetext = value;
    decodeResult.formatted.items.push({
      type: "freetext",
      code: "FREE_TEXT",
      label: "Free Text",
      value
    });
  }
  static door_event(decodeResult, name, state) {
    decodeResult.raw.door_event = {
      door: name,
      state
    };
    decodeResult.formatted.items.push({
      type: "door_event",
      code: "DOOR",
      label: "Door Event",
      value: `${name} ${state}`
    });
  }
  static position(decodeResult, value) {
    if (!value || isNaN(value.latitude) || isNaN(value.longitude)) {
      return;
    }
    decodeResult.raw.position = value;
    decodeResult.formatted.items.push({
      type: "aircraft_position",
      code: "POS",
      label: "Aircraft Position",
      value: CoordinateUtils.coordinateString(value)
    });
  }
  static altitude(decodeResult, value) {
    if (isNaN(value)) {
      return;
    }
    decodeResult.raw.altitude = value;
    decodeResult.formatted.items.push({
      type: "altitude",
      code: "ALT",
      label: "Altitude",
      value: `${decodeResult.raw.altitude} feet`
    });
  }
  static flightNumber(decodeResult, value) {
    if (value.length === 0) {
      return;
    }
    decodeResult.raw.flight_number = value;
    decodeResult.formatted.items.push({
      type: "flight_number",
      code: "FLIGHT",
      label: "Flight Number",
      value: decodeResult.raw.flight_number
    });
  }
  static callsign(decodeResult, value) {
    decodeResult.raw.callsign = value;
    decodeResult.formatted.items.push({
      type: "callsign",
      code: "CALLSIGN",
      label: "Callsign",
      value: decodeResult.raw.callsign
    });
  }
  static departureAirport(decodeResult, value, type = "ICAO") {
    if (type === "ICAO") {
      decodeResult.raw.departure_icao = value;
      decodeResult.formatted.items.push({
        type: "icao",
        code: "ORG",
        label: "Origin",
        value
      });
    } else {
      decodeResult.raw.departure_iata = value;
      decodeResult.formatted.items.push({
        type: "iata",
        code: "ORG",
        label: "Origin",
        value
      });
    }
  }
  static departureRunway(decodeResult, value) {
    decodeResult.raw.departure_runway = value;
    decodeResult.formatted.items.push({
      type: "runway",
      code: "DEPRWY",
      label: "Departure Runway",
      value: decodeResult.raw.departure_runway
    });
  }
  static arrivalAirport(decodeResult, value, type = "ICAO") {
    if (type === "ICAO") {
      decodeResult.raw.arrival_icao = value;
      decodeResult.formatted.items.push({
        type: "icao",
        code: "DST",
        label: "Destination",
        value
      });
    } else {
      decodeResult.raw.arrival_iata = value;
      decodeResult.formatted.items.push({
        type: "iata",
        code: "DST",
        label: "Destination",
        value
      });
    }
  }
  static alternateAirport(decodeResult, value) {
    decodeResult.raw.alternate_icao = value;
    decodeResult.formatted.items.push({
      type: "icao",
      code: "ALT_DST",
      label: "Alternate Destination",
      value: decodeResult.raw.alternate_icao
    });
  }
  static eta(decodeResult, time, type = "tod") {
    if (type === "tod") {
      decodeResult.raw.eta_time = time;
      decodeResult.formatted.items.push({
        type: "time_of_day",
        code: "ETA",
        label: "Estimated Time of Arrival",
        value: DateTimeUtils.timestampToString(time, "tod")
      });
    } else {
      decodeResult.raw.eta_date = time;
      decodeResult.formatted.items.push({
        type: "epoch",
        code: "ETA",
        label: "Estimated Time of Arrival",
        value: DateTimeUtils.timestampToString(time, "epoch")
      });
    }
  }
  static arrivalRunway(decodeResult, value) {
    decodeResult.raw.arrival_runway = value;
    decodeResult.formatted.items.push({
      type: "runway",
      code: "ARWY",
      label: "Arrival Runway",
      value: decodeResult.raw.arrival_runway
    });
  }
  static alternateRunway(decodeResult, value) {
    decodeResult.raw.alternate_runway = value;
    decodeResult.formatted.items.push({
      type: "runway",
      code: "ALT_ARWY",
      label: "Alternate Runway",
      value: decodeResult.raw.alternate_runway
    });
  }
  static currentFuel(decodeResult, value) {
    decodeResult.raw.fuel_on_board = value;
    decodeResult.formatted.items.push({
      type: "fuel_on_board",
      code: "FOB",
      label: "Fuel On Board",
      value: decodeResult.raw.fuel_on_board.toString()
    });
  }
  static remainingFuel(decodeResult, value) {
    decodeResult.raw.fuel_remaining = value;
    decodeResult.formatted.items.push({
      type: "fuel_remaining",
      code: "FUEL",
      label: "Fuel Remaining",
      value: decodeResult.raw.fuel_remaining.toString()
    });
  }
  static checksum(decodeResult, value) {
    decodeResult.raw.checksum = Number("0x" + value);
    decodeResult.formatted.items.push({
      type: "message_checksum",
      code: "CHECKSUM",
      label: "Message Checksum",
      value: "0x" + ("0000" + decodeResult.raw.checksum.toString(16)).slice(-4)
    });
  }
  static groundspeed(decodeResult, value) {
    decodeResult.raw.groundspeed = value;
    decodeResult.formatted.items.push({
      type: "aircraft_groundspeed",
      code: "GSPD",
      label: "Aircraft Groundspeed",
      value: `${decodeResult.raw.groundspeed} knots`
    });
  }
  static temperature(decodeResult, value) {
    if (value.length === 0) {
      return;
    }
    decodeResult.raw.outside_air_temperature = Number(value.replace("M", "-").replace("P", "+"));
    decodeResult.formatted.items.push({
      type: "outside_air_temperature",
      code: "OATEMP",
      label: "Outside Air Temperature (C)",
      value: `${decodeResult.raw.outside_air_temperature} degrees`
    });
  }
  static heading(decodeResult, value) {
    decodeResult.raw.heading = value;
    decodeResult.formatted.items.push({
      type: "heading",
      code: "HDG",
      label: "Heading",
      value: `${decodeResult.raw.heading}`
    });
  }
  static tail(decodeResult, value) {
    decodeResult.raw.tail = value;
    decodeResult.formatted.items.push({
      type: "tail",
      code: "TAIL",
      label: "Tail",
      value: decodeResult.raw.tail
    });
  }
  static out(decodeResult, time) {
    decodeResult.raw.out_time = time;
    decodeResult.formatted.items.push({
      type: "time_of_day",
      code: "OUT",
      label: "Out of Gate Time",
      value: DateTimeUtils.timestampToString(time, "tod")
    });
  }
  static off(decodeResult, time, type = "tod") {
    if (type === "tod") {
      decodeResult.raw.off_time = time;
      decodeResult.formatted.items.push({
        type: "time_of_day",
        code: "OFF",
        label: "Takeoff Time",
        value: DateTimeUtils.timestampToString(time, "tod")
      });
    } else {
      decodeResult.raw.off_date = time;
      decodeResult.formatted.items.push({
        type: "epoch",
        code: "OFF",
        label: "Takeoff Time",
        value: DateTimeUtils.timestampToString(time, "epoch")
      });
    }
  }
  static on(decodeResult, time) {
    decodeResult.raw.on_time = time;
    decodeResult.formatted.items.push({
      type: "time_of_day",
      code: "ON",
      label: "Landing Time",
      value: DateTimeUtils.timestampToString(time, "tod")
    });
  }
  static in(decodeResult, time) {
    decodeResult.raw.in_time = time;
    decodeResult.formatted.items.push({
      type: "time_of_day",
      code: "IN",
      label: "In Gate Time",
      value: DateTimeUtils.timestampToString(time, "tod")
    });
  }
  static time_of_day(decodeResult, time) {
    decodeResult.raw.time_of_day = time;
    decodeResult.formatted.items.push({
      type: "time_of_day",
      code: "MSG_TOD",
      label: "Message Timestamp",
      value: DateTimeUtils.timestampToString(time, "tod")
    });
  }
  static day(decodeResult, day) {
    decodeResult.raw.day = day;
    decodeResult.formatted.items.push({
      type: "day",
      code: "MSG_DAY",
      label: "Day of Month",
      value: `${day}`
    });
  }
  static month(decodeResult, month) {
    decodeResult.raw.month = month;
    decodeResult.formatted.items.push({
      type: "month",
      code: "MSG_MON",
      label: "Month of Year",
      value: `${month}`
    });
  }
  static departureDay(decodeResult, day) {
    decodeResult.raw.departure_day = day;
    decodeResult.formatted.items.push({
      type: "day",
      code: "DEP_DAY",
      label: "Departure Day",
      value: `${day}`
    });
  }
  static arrivalDay(decodeResult, day) {
    decodeResult.raw.arrival_day = day;
    decodeResult.formatted.items.push({
      type: "day",
      code: "ARR_DAY",
      label: "Arrival Day",
      value: `${day}`
    });
  }
  static text(decodeResult, text) {
    decodeResult.raw.text = text;
    decodeResult.formatted.items.push({
      type: "text",
      code: "TEXT",
      label: "Text Message",
      value: text
    });
  }
  static unknown(decodeResult, value, sep = ",") {
    if (!decodeResult.remaining.text)
      decodeResult.remaining.text = value;
    else
      decodeResult.remaining.text += sep + value;
  }
  static unknownArr(decodeResult, value, sep = ",") {
    this.unknown(decodeResult, value.join(sep), sep);
  }
};

// lib/plugins/Label_5Z_Slash.ts
var Label_5Z_Slash = class extends DecoderPlugin {
  name = "label-5z-slash";
  descriptions = {
    B1: "Request Weight and Balance",
    B3: "Request Departure Clearance",
    CD: "Weight and Balance",
    CG: "Request Pre-departure clearance, PDC",
    CM: "Crew Scheduling",
    C3: "Off Message",
    C4: "Flight Dispatch",
    C5: "Maintenance Message",
    C6: "Customer Service",
    10: "PIREP",
    C11: "International PIREP",
    DS: "Late Message",
    D3: "Holding Pattern Message",
    D6: "From-To + Date",
    D7: "From-To + Alternate + Time",
    EO: "In Range",
    ET: "Expected Time",
    PW: "Position Weather",
    RL: "Request Release",
    R3: "Request HOWGOZIT Message",
    R4: "Request the Latest POSBD",
    TC: "From-To Fuel",
    WB: "From-To",
    W1: "Request Weather for City"
  };
  qualifiers() {
    return {
      labels: ["5Z"],
      preambles: ["/"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Airline Designated Downlink";
    const lines = message.text.split("\r\n");
    if (lines[0] === "/TXT") {
      ResultFormatter.text(decodeResult, lines.slice(1).join("\r\n"));
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "full";
      return decodeResult;
    }
    const data = lines[0].split("/");
    const header = data[1].split(" ");
    const type = header[0];
    const typeDescription = this.descriptions[type];
    if (typeDescription) {
      decodeResult.raw.airline = "United Airlines";
      decodeResult.formatted.items.push({
        type: "airline",
        code: "AIRLINE",
        label: "Airline",
        value: "United Airlines"
      });
      decodeResult.raw.message_type = type;
      decodeResult.formatted.items.push({
        type: "message_type",
        code: "MSG_TYPE",
        label: "Message Type",
        value: `${typeDescription} (${type})`
      });
      if (type === "B3" && data[1] === "B3 TO DATA REQ    ") {
        const info = data[2].split(" ");
        ResultFormatter.departureAirport(decodeResult, info[1]);
        ResultFormatter.arrivalAirport(decodeResult, info[2]);
        decodeResult.raw.day = Number(info[3]);
        ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(info[4]));
        ResultFormatter.arrivalRunway(decodeResult, info[5].slice(1));
        ResultFormatter.unknownArr(decodeResult, data.slice(3), "/");
      } else if (type === "B3") {
        ResultFormatter.departureAirport(decodeResult, header[1].substring(0, 3), "IATA");
        ResultFormatter.arrivalAirport(decodeResult, header[1].substring(3), "IATA");
        decodeResult.raw.day = Number(header[2]);
        ResultFormatter.arrivalRunway(decodeResult, header[3].slice(1));
        if (header.length > 4) {
          ResultFormatter.unknownArr(decodeResult, header.slice(4), "/");
        }
      } else if (type === "C3" && data[1] === "C3 GATE REQ       ") {
        const info = data[2].split(" ");
        ResultFormatter.departureAirport(decodeResult, info[1]);
        ResultFormatter.arrivalAirport(decodeResult, info[2]);
        decodeResult.raw.day = Number(info[3]);
        ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(info[4]));
        ResultFormatter.unknownArr(decodeResult, info.slice(5), " ");
      } else if (type === "C3") {
        ResultFormatter.departureAirport(decodeResult, header[1].substring(0, 3), "IATA");
        ResultFormatter.arrivalAirport(decodeResult, header[1].substring(3), "IATA");
      } else if (type === "ET") {
        const airports = data[2].split(" ");
        ResultFormatter.departureAirport(decodeResult, airports[1]);
        ResultFormatter.arrivalAirport(decodeResult, airports[2]);
        decodeResult.raw.day = Number(airports[3]);
        ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(airports[4]));
        const estimates = data[3].split(" ");
        ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(estimates[1]));
        ResultFormatter.unknown(decodeResult, estimates[2]);
      } else {
        if (options.debug) {
          console.log(`Decoder: Unkown 5Z RDC format: ${message.text}`);
        }
      }
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = decodeResult.remaining.text ? "partial" : "full";
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown 5Z message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_10_LDR.ts
var Label_10_LDR = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-10-ldr";
  qualifiers() {
    return {
      labels: ["10"],
      preambles: ["LDR"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const parts = message.text.split(",");
    if (parts.length < 17) {
      if (options.debug) {
        console.log(`Decoder: Unknown 10 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const lat = parts[5];
    const lon = parts[6];
    const position = {
      latitude: (lat[0] === "N" ? 1 : -1) * Number(lat.substring(1).trim()),
      longitude: (lon[0] === "E" ? 1 : -1) * Number(lon.substring(1).trim())
    };
    ResultFormatter.position(decodeResult, position);
    ResultFormatter.altitude(decodeResult, Number(parts[7]));
    ResultFormatter.departureAirport(decodeResult, parts[9]);
    ResultFormatter.arrivalAirport(decodeResult, parts[10]);
    ResultFormatter.alternateAirport(decodeResult, parts[11]);
    ResultFormatter.arrivalRunway(decodeResult, parts[12].split("/")[0]);
    const altRwy = [parts[13].split("/")[0], parts[14].split("/")[0]].filter((r) => r != "").join(",");
    if (altRwy != "") {
      ResultFormatter.alternateRunway(decodeResult, altRwy);
    }
    ResultFormatter.unknownArr(decodeResult, [...parts.slice(0, 5), ...parts.slice(15)]);
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_10_POS.ts
var Label_10_POS = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-10-pos";
  qualifiers() {
    return {
      labels: ["10"],
      preambles: ["POS"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const parts = message.text.split(",");
    if (parts.length !== 12) {
      if (options.debug) {
        console.log(`Decoder: Unknown 10 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const lat = parts[1].trim();
    const lon = parts[2].trim();
    const position = {
      latitude: (lat[0] === "N" ? 1 : -1) * Number(lat.substring(1).trim()) / 100,
      longitude: (lon[0] === "E" ? 1 : -1) * Number(lon.substring(1).trim()) / 100
    };
    ResultFormatter.position(decodeResult, position);
    ResultFormatter.altitude(decodeResult, Number(parts[7]));
    ResultFormatter.unknownArr(decodeResult, [parts[0], ...parts.slice(3, 7), ...parts.slice(8)]);
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_10_Slash.ts
var Label_10_Slash = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-10-slash";
  qualifiers() {
    return {
      labels: ["10"],
      preambles: ["/"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const parts = message.text.split("/");
    if (parts.length < 17) {
      if (options.debug) {
        console.log(`Decoder: Unknown 10 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const lat = parts[1];
    const lon = parts[2];
    const position = {
      latitude: (lat[0] === "N" ? 1 : -1) * Number(lat.substring(1)),
      longitude: (lon[0] === "E" ? 1 : -1) * Number(lon.substring(1))
    };
    ResultFormatter.position(decodeResult, position);
    ResultFormatter.heading(decodeResult, Number(parts[5]));
    ResultFormatter.altitude(decodeResult, 100 * Number(parts[6]));
    ResultFormatter.arrivalAirport(decodeResult, parts[7]);
    ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[8]));
    const waypoints = [{
      name: parts[11]
    }, {
      name: parts[12],
      time: DateTimeUtils.convertHHMMSSToTod(parts[13]),
      timeFormat: "tod"
    }, {
      name: parts[14],
      time: DateTimeUtils.convertHHMMSSToTod(parts[15]),
      timeFormat: "tod"
    }];
    ResultFormatter.route(decodeResult, { waypoints });
    if (parts[16]) {
      ResultFormatter.departureAirport(decodeResult, parts[16]);
    }
    ResultFormatter.unknownArr(decodeResult, [parts[3], parts[4], ...parts.slice(9, 11), ...parts.slice(17)], "/");
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_12_N_Space.ts
var Label_12_N_Space = class extends DecoderPlugin {
  name = "label-12-n-space";
  qualifiers() {
    return {
      labels: ["12"],
      preambles: ["N ", "S "]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const variant1Regex = /^(?<lat>[NS])\s(?<lat_coord>.*),(?<long>[EW])\s*(?<long_coord>.*),(?<alt>.*),(?<unkwn1>.*),\s*(?<unkwn2>.*),.(?<airframe>.*),(?<unkwn3>.*)$/;
    let results = message.text.match(variant1Regex);
    if (results?.groups) {
      if (options.debug) {
        console.log(`Label 12 N : results`);
        console.log(results);
      }
      ResultFormatter.position(decodeResult, {
        latitude: Number(results.groups.lat_coord) * (results.groups.lat == "N" ? 1 : -1),
        longitude: Number(results.groups.long_coord) * (results.groups.long == "E" ? 1 : -1)
      });
      const altitude = results.groups.alt == "GRD" || results.groups.alt == "***" ? 0 : Number(results.groups.alt);
      ResultFormatter.altitude(decodeResult, altitude);
      ResultFormatter.unknownArr(decodeResult, [results.groups.unkwn1, results.groups.unkwn2, results.groups.unkwn3]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
      return decodeResult;
    }
    if (options.debug) {
      console.log(`Decoder: Unknown 12 message: ${message.text}`);
    }
    ResultFormatter.unknown(decodeResult, message.text);
    decodeResult.decoded = false;
    decodeResult.decoder.decodeLevel = "none";
    return decodeResult;
  }
};

// lib/plugins/Label_12_POS.ts
var Label_12_POS = class extends DecoderPlugin {
  name = "label-12-pos";
  qualifiers() {
    return {
      labels: ["12"],
      preambles: ["POS"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const data = message.text.substring(3).split(",");
    if (!message.text.startsWith("POS") || data.length !== 12) {
      if (options.debug) {
        console.log(`Decoder: Unknown 12 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const lat = data[0].substring(0, 8);
    const lon = data[0].substring(8);
    ResultFormatter.position(decodeResult, {
      latitude: CoordinateUtils.getDirection(lat[0]) * CoordinateUtils.dmsToDecimalDegrees(Number(lat.substring(1, 4)), Number(lat.substring(4, 6)), Number(lat.substring(6, 8))),
      longitude: CoordinateUtils.getDirection(lon[0]) * CoordinateUtils.dmsToDecimalDegrees(Number(lon.substring(1, 4)), Number(lon.substring(4, 6)), Number(lon.substring(6, 8)))
    });
    ResultFormatter.unknown(decodeResult, data[1]);
    ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[2]));
    ResultFormatter.altitude(decodeResult, 10 * Number(data[3]));
    ResultFormatter.unknownArr(decodeResult, data.slice(4, 7));
    ResultFormatter.currentFuel(decodeResult, Number(data[7].substring(3).trim()));
    ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[8].substring(3).trim()));
    ResultFormatter.departureAirport(decodeResult, data[9]);
    ResultFormatter.arrivalAirport(decodeResult, data[10]);
    ResultFormatter.unknown(decodeResult, data[11]);
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_13Through18_Slash.ts
var Label_13Through18_Slash = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-13-18-slash";
  qualifiers() {
    return {
      labels: ["13", "14", "15", "16", "17", "18"],
      preambles: ["/"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    const lines = message.text.split("\r\n");
    const parts = lines[0].split("/");
    const labelNumber = Number(parts[1].substring(0, 2));
    decodeResult.formatted.description = getMsgType(labelNumber);
    if (labelNumber !== 18 && parts.length !== 4 || labelNumber === 18 && parts.length !== 7) {
      if (options?.debug) {
        console.log(`Decoder: Unknown OOOI message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const data = parts[2].split(" ");
    ResultFormatter.departureAirport(decodeResult, data[1]);
    ResultFormatter.arrivalAirport(decodeResult, data[2]);
    decodeResult.raw.day = Number(data[3]);
    const time = DateTimeUtils.convertHHMMSSToTod(data[4]);
    if (labelNumber === 13) {
      ResultFormatter.out(decodeResult, time);
    } else if (labelNumber === 14) {
      ResultFormatter.off(decodeResult, time);
    } else if (labelNumber === 15) {
      ResultFormatter.on(decodeResult, time);
    } else if (labelNumber === 16) {
      ResultFormatter.in(decodeResult, time);
    }
    if (parts.length === 7) {
      ResultFormatter.unknownArr(decodeResult, parts.slice(4), "/");
    }
    for (let i = 1; i < lines.length; i++) {
      if (lines[i].startsWith("/LOC")) {
        const location = lines[i].substring(5).split(",");
        let position;
        if (location[0].startsWith("+") || location[0].startsWith("-")) {
          position = { latitude: Number(location[0]), longitude: Number(location[1]) };
        } else {
          position = {
            latitude: CoordinateUtils.getDirection(location[0][0]) * CoordinateUtils.dmsToDecimalDegrees(Number(location[0].substring(1, 3)), Number(location[0].substring(3, 5)), Number(location[0].substring(5, 7))),
            longitude: CoordinateUtils.getDirection(location[1][0]) * CoordinateUtils.dmsToDecimalDegrees(Number(location[1].substring(1, 4)), Number(location[1].substring(4, 6)), Number(location[1].substring(6, 8)))
          };
        }
        ResultFormatter.position(decodeResult, position);
      } else {
        ResultFormatter.unknown(decodeResult, lines[i], "\r\n");
      }
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = decodeResult.remaining.text ? "partial" : "full";
    return decodeResult;
  }
};
function getMsgType(labelNumber) {
  if (labelNumber === 13) {
    return "Out of Gate Report";
  }
  if (labelNumber === 14) {
    return "Takeoff Report";
  }
  if (labelNumber === 15) {
    return "On Ground Report";
  }
  if (labelNumber === 16) {
    return "In Gate Report";
  }
  if (labelNumber === 17) {
    return "Post Report";
  }
  if (labelNumber === 18) {
    return "Post Times Report";
  }
  return "Unknown";
}

// lib/plugins/Label_15.ts
var Label_15 = class extends DecoderPlugin {
  name = "label-15";
  qualifiers() {
    return {
      labels: ["15"],
      preambles: ["(2"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    if (message.text.startsWith("(2") && message.text.endsWith("(Z")) {
      const between = message.text.substring(2, message.text.length - 2);
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinatesDecimalMinutes(between.substring(0, 13)));
      if (between.length === 25) {
        ResultFormatter.unknown(decodeResult, between.substring(13, 19));
        const alt = between.substring(19, 22);
        if (alt != "---") {
          ResultFormatter.altitude(decodeResult, 100 * Number(alt));
        }
        ResultFormatter.temperature(decodeResult, between.substring(22).replaceAll(" ", "0"));
      } else if (between.substring(13, 16) === "OFF") {
        const ddmmyy = between.substring(16, 22);
        const hhmm = between.substring(22, 26);
        if (ddmmyy != "------") {
          const mmddyy = ddmmyy.substring(2, 4) + ddmmyy.substring(0, 2) + ddmmyy.substring(4);
          ResultFormatter.off(decodeResult, DateTimeUtils.convertDateTimeToEpoch(hhmm + "00", mmddyy), "epoch");
        } else {
          ResultFormatter.off(decodeResult, DateTimeUtils.convertHHMMSSToTod(hhmm), "tod");
        }
        ResultFormatter.unknown(decodeResult, between.substring(26));
      } else {
        ResultFormatter.unknown(decodeResult, between.substring(26));
      }
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown 15 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_15_FST.ts
var Label_15_FST = class extends DecoderPlugin {
  name = "label-15-fst";
  qualifiers() {
    return {
      labels: ["15"],
      preambles: ["FST01"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const parts = message.text.split(" ");
    const header = parts[0];
    const stringCoords = header.substring(13);
    const firstChar = stringCoords.substring(0, 1);
    const middleChar = stringCoords.substring(7, 8);
    decodeResult.raw.position = {};
    if ((firstChar === "N" || firstChar === "S") && (middleChar === "W" || middleChar === "E")) {
      const lat = Number(stringCoords.substring(1, 7)) / 1e4 * (firstChar === "S" ? -1 : 1);
      const lon = Number(stringCoords.substring(8, 15)) / 1e4 * (middleChar === "W" ? -1 : 1);
      ResultFormatter.position(decodeResult, { latitude: lat, longitude: lon });
      ResultFormatter.altitude(decodeResult, Number(stringCoords.substring(15)) * 100);
    } else {
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.departureAirport(decodeResult, header.substring(5, 9));
    ResultFormatter.arrivalAirport(decodeResult, header.substring(9, 13));
    ResultFormatter.unknownArr(decodeResult, parts.slice(1), " ");
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_16_N_Space.ts
var Label_16_N_Space = class extends DecoderPlugin {
  name = "label-16-n-space";
  qualifiers() {
    return {
      labels: ["16"],
      preambles: ["N ", "S "]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    let variant1Regex = /^(?<lat>[NS])\s(?<lat_coord>.*),(?<long>[EW])\s*(?<long_coord>.*),(?<alt>.*),(?<unkwn1>.*),\s*(?<unkwn2>.*)$/;
    let variant2Regex = /^(?<lat>[NS])\s(?<lat_coord>.*)\/(?<long>[EW])\s*(?<long_coord>.*)$/;
    let results = message.text.match(variant1Regex);
    if (results?.groups) {
      if (options.debug) {
        console.log(`Label 16 N : results`);
        console.log(results);
      }
      let pos = {
        latitude: Number(results.groups.lat_coord) * (results.groups.lat == "N" ? 1 : -1),
        longitude: Number(results.groups.long_coord) * (results.groups.long == "E" ? 1 : -1)
      };
      const altitude = results.groups.alt == "GRD" || results.groups.alt == "***" ? 0 : Number(results.groups.alt);
      ResultFormatter.position(decodeResult, pos);
      ResultFormatter.altitude(decodeResult, altitude);
      ResultFormatter.unknownArr(decodeResult, [results.groups.unkwn1, results.groups.unkwn2]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
      return decodeResult;
    }
    results = message.text.match(variant2Regex);
    if (results?.groups) {
      if (options.debug) {
        console.log(`Label 16 N : results`);
        console.log(results);
      }
      let pos = {
        latitude: Number(results.groups.lat_coord) * (results.groups.lat == "N" ? 1 : -1),
        longitude: Number(results.groups.long_coord) * (results.groups.long == "E" ? 1 : -1)
      };
      ResultFormatter.position(decodeResult, pos);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "full";
      return decodeResult;
    }
    if (options.debug) {
      console.log(`Decoder: Unknown 16 message: ${message.text}`);
    }
    ResultFormatter.unknown(decodeResult, message.text);
    decodeResult.decoded = false;
    decodeResult.decoder.decodeLevel = "none";
    return decodeResult;
  }
};

// lib/plugins/Label_16_POSA1.ts
var Label_16_POSA1 = class extends DecoderPlugin {
  name = "label-16-posa1";
  qualifiers() {
    return {
      labels: ["16"],
      preambles: ["POSA1"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const fields = message.text.split(",");
    if (fields.length !== 11 || !fields[0].startsWith("POSA1")) {
      if (options.debug) {
        console.log(`Decoder: Unknown 16 message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinates(fields[0].substring(5)));
    const waypoint = fields[1].trim();
    const time = DateTimeUtils.convertHHMMSSToTod(fields[2]);
    ResultFormatter.altitude(decodeResult, Number(fields[3]) * 100);
    const nextWaypoint = fields[4].trim();
    const nextTime = DateTimeUtils.convertHHMMSSToTod(fields[5]);
    ResultFormatter.unknownArr(decodeResult, fields.slice(6), ",");
    ResultFormatter.route(decodeResult, { waypoints: [
      { name: waypoint, time, timeFormat: "tod" },
      { name: nextWaypoint, time: nextTime, timeFormat: "tod" }
    ] });
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_16_TOD.ts
var Label_16_TOD = class extends DecoderPlugin {
  name = "label-16-tod";
  qualifiers() {
    return {
      labels: ["16"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const fields = message.text.split(",");
    const time = DateTimeUtils.convertHHMMSSToTod(fields[0]);
    if (fields.length !== 5 || Number.isNaN(time)) {
      if (options.debug) {
        console.log(`Decoder: Unknown 16 message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.time_of_day(decodeResult, time);
    if (fields[1] !== "") {
      ResultFormatter.altitude(decodeResult, Number(fields[1]));
    }
    ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[2]));
    ResultFormatter.unknown(decodeResult, fields[3]);
    const temp = fields[4].split("/");
    const posFields = temp[0].split(" ");
    ResultFormatter.position(decodeResult, {
      latitude: CoordinateUtils.getDirection(posFields[0]) * Number(posFields[1]),
      longitude: CoordinateUtils.getDirection(posFields[2]) * Number(posFields[3])
    });
    if (temp.length > 1) {
      ResultFormatter.flightNumber(decodeResult, temp[1]);
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/utils/flight_plan_utils.ts
var FlightPlanUtils = class _FlightPlanUtils {
  /**
   * Processes flight plan data
   * 
   * Expected format is [header, key1, val1, ... keyN, valN]
   * 
   * @param decodeResult - results
   * @param data - original message split by ':'
   * @returns whether all fields were processed or not
   */
  static processFlightPlan(decodeResult, data) {
    let allKnownFields = _FlightPlanUtils.parseHeader(decodeResult, data[0]);
    for (let i = 1; i < data.length; i += 2) {
      const key = data[i];
      const value = data[i + 1];
      switch (key) {
        case "A":
          addProcedure(decodeResult, value, "arrival");
          break;
        case "AA":
          addArrivalAirport(decodeResult, value);
          break;
        case "AP":
          addProcedure(decodeResult, value, "approach");
          break;
        case "CR":
          addCompanyRoute(decodeResult, value);
          break;
        case "D":
          addProcedure(decodeResult, value, "departure");
          break;
        case "DA":
          addDepartureAirport(decodeResult, value);
          break;
        case "F":
          addRoute(decodeResult, value);
          break;
        case "R":
          addRunway(decodeResult, value);
          break;
        // case 'WS': // something about routes, has altitude, so current parsing won't work
        // break;
        default:
          if (allKnownFields) {
            decodeResult.remaining.text = "";
            allKnownFields = false;
          }
          decodeResult.remaining.text += `:${key}:${value}`;
          decodeResult.decoder.decodeLevel = "partial";
      }
    }
    return allKnownFields;
  }
  static parseHeader(decodeResult, header) {
    let allKnownFields = true;
    if (header.startsWith("RF")) {
      decodeResult.formatted.items.push({
        type: "status",
        code: "ROUTE_STATUS",
        label: "Route Status",
        value: "Route Filed"
      });
      decodeResult.raw.route_status = "RF";
      if (header.length > 2) {
        addRoute(decodeResult, header.substring(2));
      }
    } else if (header.startsWith("RP")) {
      decodeResult.raw.route_status = "RP";
      decodeResult.formatted.items.push({
        type: "status",
        code: "ROUTE_STATUS",
        label: "Route Status",
        value: "Route Planned"
      });
      decodeResult.raw.route_status = header;
    } else if (header.startsWith("RI")) {
      decodeResult.raw.route_status = "RI";
      decodeResult.formatted.items.push({
        type: "status",
        code: "ROUTE_STATUS",
        label: "Route Status",
        value: "Route Inactive"
      });
    } else {
      decodeResult.remaining.text += header;
      allKnownFields = false;
    }
    return allKnownFields;
  }
};
function addArrivalAirport(decodeResult, value) {
  ResultFormatter.arrivalAirport(decodeResult, value);
}
function addDepartureAirport(decodeResult, value) {
  ResultFormatter.departureAirport(decodeResult, value);
}
function addRunway(decodeResult, value) {
  if (value.length === 8) {
    ResultFormatter.arrivalRunway(decodeResult, value.substring(4, 7));
  }
  ResultFormatter.departureRunway(decodeResult, value.substring(0, 3));
}
function addRoute(decodeResult, value) {
  const route = value.split(".");
  ResultFormatter.route(decodeResult, { waypoints: route.map((leg) => RouteUtils.getWaypoint(leg)) });
}
function addProcedure(decodeResult, value, type) {
  if (decodeResult.raw.procedures === void 0) {
    decodeResult.raw.procedures = [];
  }
  const data = value.split(".");
  let waypoints;
  if (data.length > 1) {
    waypoints = data.slice(1).map((leg) => RouteUtils.getWaypoint(leg));
  }
  const route = { name: data[0], waypoints };
  decodeResult.raw.procedures.push({ type, route });
  const procedureName = type.substring(0, 1).toUpperCase() + type.slice(1);
  let procedureValue = route.name;
  decodeResult.formatted.items.push({
    type: `procedure`,
    code: "proc",
    label: `${procedureName} Procedure`,
    value: RouteUtils.routeToString(route)
  });
}
function addCompanyRoute(decodeResult, value) {
  const segments = value.split(".");
  const parens_idx = segments[0].indexOf("(");
  let name;
  let runway;
  if (parens_idx === -1) {
    name = segments[0];
  } else {
    name = segments[0].slice(0, parens_idx);
    runway = segments[0].slice(parens_idx + 1, segments[0].indexOf(")"));
  }
  let waypoints;
  if (segments.length > 1) {
    waypoints = segments.slice(1).map((leg) => RouteUtils.getWaypoint(leg));
  }
  decodeResult.raw.company_route = {
    name,
    runway,
    waypoints
  };
  decodeResult.formatted.items.push({
    type: "company_route",
    code: "CR",
    label: "Company Route",
    value: RouteUtils.routeToString(decodeResult.raw.company_route)
  });
}

// lib/utils/h1_helper.ts
var H1Helper = class _H1Helper {
  static decodeH1Message(decodeResult, message) {
    const checksum = message.slice(-4);
    const data = message.slice(0, message.length - 4);
    const fields = data.split("/");
    const canDecode = parseMessageType(decodeResult, fields[0]);
    if (!canDecode) {
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return false;
    }
    for (let i = 1; i < fields.length; ++i) {
      if (fields[i].startsWith("FN")) {
        decodeResult.raw.flight_number = fields[i].substring(2);
      } else if (fields[i].startsWith("SN")) {
        decodeResult.raw.serial_number = fields[i].substring(2);
      } else if (fields[i].startsWith("DC")) {
        processDC(decodeResult, fields[i].substring(2).split(","));
      } else if (fields[i].startsWith("TS")) {
        _H1Helper.processTS(decodeResult, fields[i].substring(2).split(","));
      } else if (fields[i].startsWith("PS")) {
        _H1Helper.processPS(decodeResult, fields[i].substring(2).split(","));
      } else if (fields[i].startsWith("DT")) {
        const data2 = fields[i].substring(2).split(",");
        processDT(decodeResult, data2);
      } else if (fields[i].startsWith("ID")) {
        processIdentification(decodeResult, fields[i].substring(2).split(","));
      } else if (fields[i].startsWith("LR")) {
        const data2 = fields[i].substring(2).split(",");
        processLR(decodeResult, data2);
      } else if (fields[i].startsWith("RI") || fields[i].startsWith("RF") || fields[i].startsWith("RP")) {
        FlightPlanUtils.processFlightPlan(decodeResult, fields[i].split(":"));
      } else if (fields[i].startsWith("PR")) {
        ResultFormatter.unknown(decodeResult, fields[i], "/");
      } else if (fields[i].startsWith("AF")) {
        processAirField(decodeResult, fields[i].substring(2).split(","));
      } else if (fields[i].startsWith("TD")) {
        processTimeOfDeparture(decodeResult, fields[i].substring(2).split(","));
      } else if (fields[i].startsWith("FX")) {
        ResultFormatter.freetext(decodeResult, fields[i].substring(2));
      } else if (fields[i].startsWith("ET")) {
        if (fields[i].length === 7) {
          ResultFormatter.day(decodeResult, Number(fields[i].substring(2, 3)));
          ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[i].substring(3)));
        } else if (fields[i].length === 8) {
          ResultFormatter.day(decodeResult, Number(fields[i].substring(2, 4)));
          ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[i].substring(4)));
        } else {
          ResultFormatter.unknown(decodeResult, fields[i], "/");
        }
      } else if (fields[i].startsWith("WD")) {
        processWindData(decodeResult, fields[i].substring(2));
      } else {
        ResultFormatter.unknown(decodeResult, fields[i], "/");
      }
    }
    if (decodeResult.formatted.items.length > 0) {
      ResultFormatter.checksum(decodeResult, checksum);
    }
    return true;
  }
  static processPS(decodeResult, data) {
    const position = CoordinateUtils.decodeStringCoordinatesDecimalMinutes(data[0]);
    if (position) {
      decodeResult.raw.position = position;
      decodeResult.formatted.items.push({
        type: "aircraft_position",
        code: "POS",
        label: "Aircraft Position",
        value: CoordinateUtils.coordinateString(position)
      });
    }
    if (data.length === 9) {
      processRoute(decodeResult, data[3], data[1], data[5], data[4], void 0);
      ResultFormatter.altitude(decodeResult, Number(data[2]) * 100);
      ResultFormatter.temperature(decodeResult, data[6]);
      ResultFormatter.unknown(decodeResult, data[7]);
      ResultFormatter.unknown(decodeResult, data[8]);
    }
    if (data.length === 14) {
      ResultFormatter.altitude(decodeResult, Number(data[3]) * 100);
      processRoute(decodeResult, data[1], data[2], data[4], data[5], data[6]);
      ResultFormatter.temperature(decodeResult, data[7]);
      ResultFormatter.unknownArr(decodeResult, data.slice(8));
    }
  }
  static processPosition(decodeResult, data) {
    const position = CoordinateUtils.decodeStringCoordinatesDecimalMinutes(data[0]);
    if (position) {
      ResultFormatter.position(decodeResult, position);
    }
    if (data.length >= 10) {
      ResultFormatter.altitude(decodeResult, Number(data[3]) * 100);
      processRoute(decodeResult, data[1], data[2], data[4], data[5], data[6]);
      ResultFormatter.temperature(decodeResult, data[7]);
      ResultFormatter.unknown(decodeResult, data[8]);
      ResultFormatter.unknown(decodeResult, data[9]);
    }
    if (data.length >= 14) {
      ResultFormatter.unknownArr(decodeResult, data.slice(10));
    }
  }
  static processTS(decodeResult, data) {
    let time = DateTimeUtils.convertDateTimeToEpoch(data[0], data[1]);
    if (Number.isNaN(time)) {
      const date = data[1].substring(2, 4) + data[1].substring(0, 2) + data[1].substring(4, 6);
      time = DateTimeUtils.convertDateTimeToEpoch(data[0], date);
    }
    decodeResult.raw.message_date = data[1];
    decodeResult.raw.message_timestamp = time;
  }
};
function processAirField(decodeResult, data) {
  if (data.length === 2) {
    ResultFormatter.departureAirport(decodeResult, data[0]);
    ResultFormatter.arrivalAirport(decodeResult, data[1]);
  } else {
    ResultFormatter.unknown(decodeResult, data.join(","), "AF/");
  }
}
function processTimeOfDeparture(decodeResult, data) {
  if (data.length === 2) {
    decodeResult.raw.plannedDepartureTime = data[0];
    decodeResult.formatted.items.push({
      type: "ptd",
      code: "ptd",
      label: "Planned Departure Time",
      value: `YYYY-MM-${data[0].substring(0, 2)}T${data[0].substring(2, 4)}:${data[0].substring(4)}:00Z`
    });
    decodeResult.raw.plannedDepartureTime = data[1];
    decodeResult.formatted.items.push({
      type: "etd",
      code: "etd",
      label: "Estimated Departure Time",
      value: `${data[1].substring(0, 2)}:${data[1].substring(2)}`
    });
  } else {
    ResultFormatter.unknown(decodeResult, data.join(","), "/TD");
  }
}
function processIdentification(decodeResult, data) {
  ResultFormatter.tail(decodeResult, data[0]);
  if (data.length > 1) {
    ResultFormatter.flightNumber(decodeResult, data[1]);
  }
  if (data.length > 2) {
    decodeResult.raw.mission_number = data[2];
  }
}
function processDT(decodeResult, data) {
  if (!decodeResult.raw.arrival_icao) {
    ResultFormatter.arrivalAirport(decodeResult, data[0]);
  } else if (decodeResult.raw.arrival_icao != data[0]) {
    ResultFormatter.unknownArr(decodeResult, data);
  }
  if (data.length > 1) {
    ResultFormatter.arrivalRunway(decodeResult, data[1]);
  }
  if (data.length > 2) {
    ResultFormatter.currentFuel(decodeResult, Number(data[2]));
  }
  if (data.length > 3) {
    ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[3]));
  }
  if (data.length > 4) {
    ResultFormatter.remainingFuel(decodeResult, Number(data[4]));
  }
  if (data.length > 5) {
    ResultFormatter.unknownArr(decodeResult, data);
  }
}
function processLR(decodeResult, data) {
  if (data.length === 19) {
    ResultFormatter.unknown(decodeResult, data[1]);
    ResultFormatter.flightNumber(decodeResult, data[2]);
    ResultFormatter.departureAirport(decodeResult, data[3]);
    ResultFormatter.arrivalAirport(decodeResult, data[4]);
    ResultFormatter.arrivalRunway(decodeResult, data[5]);
    ResultFormatter.unknown(decodeResult, data.slice(6, 19).join(","));
  } else {
    ResultFormatter.unknown(decodeResult, data.join(","));
  }
}
function parseMessageType(decodeResult, messageType) {
  const parts = messageType.split("#");
  if (parts.length == 1) {
    if (parts[0].startsWith("POS")) {
      H1Helper.processPosition(decodeResult, parts[0].substring(3).split(","));
      return processMessageType(decodeResult, "POS");
    } else if (parts[0].length === 13) {
      if (processMessageType(decodeResult, parts[0].substring(10))) {
        ResultFormatter.unknown(decodeResult, parts[0].substring(0, 4));
        ResultFormatter.flightNumber(decodeResult, parts[0].slice(4, 10));
        return true;
      }
    }
    return processMessageType(decodeResult, parts[0].substring(0, 3));
  } else if (parts.length == 2) {
    if (parts[0].length > 0) {
      ResultFormatter.unknown(decodeResult, parts[0].substring(0, 4));
      ResultFormatter.flightNumber(decodeResult, parts[0].substring(4));
      ResultFormatter.unknown(decodeResult, parts[1].length == 5 ? parts[1].substring(0, 2) : parts[1].substring(0, 3), "#");
    }
    const type = parts[1].length == 5 ? parts[1].substring(2, 5) : parts[1].substring(3, 6);
    if (parts[1].substring(3, 6) === "POS" && parts[1].length > 6) {
      H1Helper.processPosition(decodeResult, parts[1].substring(6).split(","));
    }
    return processMessageType(decodeResult, type);
  } else {
    ResultFormatter.unknown(decodeResult, messageType);
    return false;
  }
}
function processMessageType(decodeResult, type) {
  if (type === "FPN") {
    decodeResult.formatted.description = "Flight Plan";
  } else if (type === "FTX") {
    decodeResult.formatted.description = "Free Text";
  } else if (type === "INI") {
    decodeResult.formatted.description = "Flight Plan Initial Report";
  } else if (type === "POS") {
    decodeResult.formatted.description = "Position Report";
  } else if (type === "PRG") {
    decodeResult.formatted.description = "Progress Report";
  } else if (type === "PWI") {
    decodeResult.formatted.description = "Weather Report";
  } else {
    decodeResult.formatted.description = "Unknown H1 Message";
    return false;
  }
  return true;
}
function processDC(decodeResult, data) {
  decodeResult.raw.message_date = data[0];
  if (data.length === 1) {
  } else if (data.length === 2) {
    const date = data[0].substring(2, 4) + data[0].substring(0, 2) + data[0].substring(4, 6);
    const time = DateTimeUtils.convertDateTimeToEpoch(data[1], data[0]);
    decodeResult.raw.message_timestamp = time;
  }
}
function processRoute(decodeResult, last, time, next, eta, then, date) {
  const lastTime = date ? DateTimeUtils.convertDateTimeToEpoch(time, date) : DateTimeUtils.convertHHMMSSToTod(time);
  const nextTime = date ? DateTimeUtils.convertDateTimeToEpoch(eta, date) : DateTimeUtils.convertHHMMSSToTod(eta);
  const timeFormat = date ? "epoch" : "tod";
  const lastWaypoint = RouteUtils.getWaypoint(last);
  lastWaypoint.time = lastTime;
  lastWaypoint.timeFormat = timeFormat;
  const nextWaypoint = RouteUtils.getWaypoint(next);
  nextWaypoint.time = nextTime;
  nextWaypoint.timeFormat = timeFormat;
  const thenWaypoint = RouteUtils.getWaypoint(then || "?");
  const waypoints = [lastWaypoint, nextWaypoint, thenWaypoint];
  decodeResult.raw.route = { waypoints };
  decodeResult.formatted.items.push({
    type: "aircraft_route",
    code: "ROUTE",
    label: "Aircraft Route",
    value: RouteUtils.routeToString(decodeResult.raw.route)
  });
}
function processWindData(decodeResult, message) {
  if (decodeResult.raw.wind_data === void 0) {
    decodeResult.raw.wind_data = [];
  }
  const flightLevel = Number(message.slice(0, 3));
  const fields = message.slice(4).split(".");
  fields.forEach((field) => {
    const data = field.split(",");
    const waypoint = data[0];
    const windData = data[1];
    const windDirection = Number(windData.slice(0, 3));
    const windSpeed = Number(windData.slice(3));
    if (data.length === 3) {
      const tempData = data[2];
      const tempFlightLevel = Number(tempData.slice(0, 3));
      const tempString = tempData.slice(3);
      const tempDegrees = Number(tempString.substring(1)) * (tempString.charAt(0) === "M" ? -1 : 1);
      decodeResult.raw.wind_data.push({
        waypoint,
        flightLevel,
        windDirection,
        windSpeed,
        temperature: {
          flightLevel: tempFlightLevel,
          degreesC: tempDegrees
        }
      });
      decodeResult.formatted.items.push({
        type: "wind_data",
        code: "WIND",
        label: "Wind Data",
        value: `${waypoint} at FL${flightLevel}: ${windDirection}\xB0 at ${windSpeed}kt, ${tempDegrees}\xB0C at FL${tempFlightLevel}`
      });
    } else {
      decodeResult.raw.wind_data.push({
        waypoint,
        flightLevel,
        windDirection,
        windSpeed
      });
      decodeResult.formatted.items.push({
        type: "wind_data",
        code: "WIND",
        label: "Wind Data",
        value: `${waypoint} at FL${flightLevel}: ${windDirection}\xB0 at ${windSpeed}kt`
      });
    }
  });
}

// lib/plugins/Label_1J_2J_FTX.ts
var Label_1J_2J_FTX = class extends DecoderPlugin {
  name = "label-1j-2j-ftx";
  qualifiers() {
    return {
      labels: ["1J", "2J"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    const msg = message.text.replace(/\n|\r/g, "");
    const decoded = H1Helper.decodeH1Message(decodeResult, msg);
    decodeResult.decoded = decoded;
    decodeResult.decoder.decodeLevel = !decodeResult.remaining.text ? "full" : "partial";
    if (decodeResult.formatted.items.length === 0) {
      if (options.debug) {
        console.log(`Decoder: Unknown 1J/2J message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_1M_Slash.ts
var Label_1M_Slash = class extends DecoderPlugin {
  name = "label-1m-slash";
  qualifiers() {
    return {
      labels: ["1M"],
      preambles: ["/"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "ETA Report";
    decodeResult.message = message;
    const results = message.text.split(/\n|\//).slice(1);
    if (results) {
      if (options.debug) {
        console.log(`Label 1M ETA: results`);
        console.log(results);
      }
      decodeResult.raw.flight_number = results[0];
      ResultFormatter.departureAirport(decodeResult, results[3]);
      ResultFormatter.arrivalAirport(decodeResult, results[4]);
      ResultFormatter.alternateAirport(decodeResult, results[5]);
      ResultFormatter.arrivalRunway(decodeResult, results[8].replace(results[4], ""));
      const yymmdd = results[2];
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertDateTimeToEpoch(results[7] + "00", yymmdd.substring(2, 4) + yymmdd.substring(4, 6) + yymmdd.substring(0, 2)), "epoch");
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_1L_3-line.ts
var Label_1L_3Line = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-1l-3-line";
  qualifiers() {
    return {
      labels: ["1L"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const lines = message.text.split("\r\n");
    if (lines.length !== 3) {
      if (options.debug) {
        console.log(`Decoder: Unknown 1L message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const parts = message.text.replaceAll("\r\n", "/").split("/");
    const data = /* @__PURE__ */ new Map();
    data.set("", parts[0]);
    for (let i = 1; i < parts.length; i++) {
      const part = parts[i].split(" ");
      data.set(part[0], part.slice(1).join(" "));
    }
    const dep = data.get("DEP");
    if (dep) {
      ResultFormatter.departureAirport(decodeResult, dep);
      data.delete("DEP");
    }
    const des = data.get("DES");
    if (des) {
      ResultFormatter.arrivalAirport(decodeResult, des);
      data.delete("DES");
    }
    const eta = data.get("ETA");
    if (eta) {
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(eta));
      data.delete("ETA");
    }
    const alt = data.get("ALT");
    if (alt) {
      ResultFormatter.altitude(decodeResult, Number(alt));
      data.delete("ALT");
    }
    const fn = data.get("FN");
    if (fn) {
      ResultFormatter.flightNumber(decodeResult, fn);
      data.delete("FN");
    }
    const day = data.get("DAY");
    const utc = data.get("UTC");
    if (day && utc) {
      decodeResult.raw.message_timestamp = Date.parse(day + " GMT+0000") / 1e3 + DateTimeUtils.convertHHMMSSToTod(utc);
      data.delete("DAY");
      data.delete("UTC");
    }
    const lat = data.get("LAT");
    const lon = data.get("LON");
    if (lat && lon) {
      ResultFormatter.position(decodeResult, {
        latitude: CoordinateUtils.getDirection(lat[0]) * Number(lat.substring(1)),
        longitude: CoordinateUtils.getDirection(lon[0]) * Number(lon.substring(1))
      });
      data.delete("LAT");
      data.delete("LON");
    }
    let remaining = "";
    for (const [key, value] of data.entries()) {
      if (key === "") {
        remaining += value;
      } else {
        remaining += `/${key} ${value}`;
      }
    }
    decodeResult.remaining.text = remaining;
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_1L_070.ts
var Label_1L_070 = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-1l-070";
  qualifiers() {
    return {
      labels: ["1L"],
      preambles: ["000000070"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    if (!message.text.startsWith("000000070")) {
      if (options.debug) {
        console.log(`Decoder: Unknown 1L message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const parts = message.text.substring(9).split(",");
    if (parts.length !== 7) {
      if (options.debug) {
        console.log(`Decoder: Unknown 1L message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.departureAirport(decodeResult, parts[0]);
    ResultFormatter.arrivalAirport(decodeResult, parts[1]);
    ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[2]));
    ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[3]));
    ResultFormatter.position(decodeResult, {
      latitude: CoordinateUtils.getDirection(parts[4][0]) * Number(parts[4].substring(1)),
      longitude: CoordinateUtils.getDirection(parts[5][0]) * Number(parts[5].substring(1))
    });
    decodeResult.remaining.text = parts[6];
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_1L_660.ts
var Label_1L_660 = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-1l-660";
  qualifiers() {
    return {
      labels: ["1L"],
      preambles: ["000000660"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    if (!message.text.startsWith("000000660")) {
      if (options.debug) {
        console.log(`Decoder: Unknown 1L message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const parts = message.text.substring(9).split(",");
    if (parts.length !== 5) {
      if (options.debug) {
        console.log(`Decoder: Unknown 1L message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const position = CoordinateUtils.decodeStringCoordinatesDecimalMinutes(parts[0]);
    if (position) {
      ResultFormatter.position(decodeResult, position);
    }
    const hhmmss = parts[1].substring(0, 6);
    ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(hhmmss));
    const fl = parts[1].substring(6, 9);
    ResultFormatter.altitude(decodeResult, Number(fl) * 100);
    const next = parts[1].substring(9);
    ResultFormatter.route(decodeResult, { waypoints: [{ name: next.trim() }] });
    decodeResult.remaining.text = parts.slice(2).join(",");
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_1L_Slash.ts
var Label_1L_Slash = class extends DecoderPlugin {
  // eslint-disable-line camelcase
  name = "label-1l-1-line";
  qualifiers() {
    return {
      labels: ["1L"],
      preambles: ["+", "-"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const parts = message.text.split("/");
    if (parts.length !== 7) {
      if (options.debug) {
        console.log(`Decoder: Unknown 1L message: ${message.text}`);
      }
      decodeResult.remaining.text = message.text;
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const data = /* @__PURE__ */ new Map();
    data.set("LAT", parts[0].replaceAll(" ", ""));
    data.set("LON", parts[1].replaceAll(" ", ""));
    for (let i = 2; i < parts.length; i++) {
      const part = parts[i].split(" ");
      data.set(part[0], part.slice(1).join(" "));
    }
    const position = {
      latitude: Number(data.get("LAT")),
      longitude: Number(data.get("LON"))
    };
    data.delete("LAT");
    data.delete("LON");
    ResultFormatter.position(decodeResult, position);
    const utc = data.get("UTC");
    if (utc) {
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(utc));
      data.delete("UTC");
    }
    const alt = data.get("ALT");
    if (alt) {
      ResultFormatter.altitude(decodeResult, Number(alt));
      data.delete("ALT");
    }
    const fob = data.get("FOB");
    if (fob) {
      ResultFormatter.currentFuel(decodeResult, Number(fob));
      data.delete("FOB");
    }
    const eta = data.get("ETA");
    if (eta) {
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(eta));
      data.delete("ETA");
    }
    let remaining = "";
    for (const [key, value] of data.entries()) {
      remaining += `/${key} ${value}`;
    }
    decodeResult.remaining.text = remaining;
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_20_POS.ts
var Label_20_POS = class extends DecoderPlugin {
  name = "label-20-pos";
  qualifiers() {
    return {
      labels: ["20"],
      preambles: ["POS"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    decodeResult.raw.preamble = message.text.substring(0, 3);
    const content = message.text.substring(3);
    const fields = content.split(",");
    if (fields.length == 11) {
      if (options.debug) {
        console.log(`DEBUG: ${this.name}: Variation 1 detected`);
      }
      const rawCoords = fields[0];
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinates(rawCoords));
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "full";
    } else if (fields.length == 5) {
      if (options.debug) {
        console.log(`DEBUG: ${this.name}: Variation 2 detected`);
      }
      const position = CoordinateUtils.decodeStringCoordinates(fields[0]);
      if (position) {
        ResultFormatter.position(decodeResult, position);
      }
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "full";
    } else {
      if (options.debug) {
        console.log(`DEBUG: ${this.name}: Unknown variation. Field count: ${fields.length}, content: ${content}`);
      }
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_21_POS.ts
var Label_21_POS = class extends DecoderPlugin {
  name = "label-21-pos";
  qualifiers() {
    return {
      labels: ["21"],
      preambles: ["POS"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    decodeResult.raw.preamble = message.text.substring(0, 3);
    const content = message.text.substring(3);
    const fields = content.split(",");
    if (fields.length == 9) {
      processPosition(decodeResult, fields[0].trim());
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[2]));
      ResultFormatter.altitude(decodeResult, Number(fields[3]));
      ResultFormatter.temperature(decodeResult, fields[6].replace(/ /g, ""));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[7]));
      ResultFormatter.arrivalAirport(decodeResult, fields[8]);
      ResultFormatter.unknownArr(decodeResult, [fields[1], fields[4], fields[5]]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`DEBUG: ${this.name}: Unknown variation. Field count: ${fields.length}, content: ${content}`);
      }
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};
function processPosition(decodeResult, value) {
  if (value.length !== 16 && value[0] !== "N" && value[0] !== "S" && value[8] !== "W" && value[8] !== "E") {
    return;
  }
  const latDir = value[0] === "N" ? 1 : -1;
  const lonDir = value[8] === "E" ? 1 : -1;
  const position = {
    latitude: latDir * Number(value.substring(1, 7)),
    longitude: lonDir * Number(value.substring(9, 15))
  };
  ResultFormatter.position(decodeResult, position);
}

// lib/plugins/Label_22_OFF.ts
var Label_22_OFF = class extends DecoderPlugin {
  name = "label-22-off";
  qualifiers() {
    return {
      labels: ["22"],
      preambles: ["OFF"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Takeoff Report";
    decodeResult.message = message;
    if (message.text.startsWith("OFF01")) {
      const fields = message.text.substring(5).split("/");
      if (fields.length != 2) {
        decodeResult.decoded = false;
        decodeResult.decoder.decodeLevel = "none";
        return decodeResult;
      }
      ResultFormatter.flightNumber(decodeResult, fields[0]);
      ResultFormatter.departureDay(decodeResult, Number(fields[1].substring(0, 2)));
      ResultFormatter.arrivalDay(decodeResult, Number(fields[1].substring(2, 4)));
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[1].substring(4, 8)));
      ResultFormatter.departureAirport(decodeResult, fields[1].substring(8, 12));
      ResultFormatter.arrivalAirport(decodeResult, fields[1].substring(12, 16));
      ResultFormatter.off(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[1].substring(16, 22)));
      ResultFormatter.unknown(decodeResult, fields[1].substring(22));
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else if (message.text.startsWith("OFF02\r\n")) {
      const fields = message.text.substring(7).split(",");
      if (fields.length != 4) {
        decodeResult.decoded = false;
        decodeResult.decoder.decodeLevel = "none";
        return decodeResult;
      }
      ResultFormatter.departureAirport(decodeResult, fields[0]);
      ResultFormatter.arrivalAirport(decodeResult, fields[1]);
      ResultFormatter.off(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[2]));
      ResultFormatter.unknown(decodeResult, fields[3]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else if (message.text.startsWith("OFF02")) {
      const fields = message.text.substring(5).split("/");
      if (fields.length != 2) {
        decodeResult.decoded = false;
        decodeResult.decoder.decodeLevel = "none";
        return decodeResult;
      }
      ResultFormatter.flightNumber(decodeResult, fields[0]);
      const position = CoordinateUtils.decodeStringCoordinatesDecimalMinutes(fields[1].substring(0, 14));
      if (position) {
        ResultFormatter.position(decodeResult, position);
      }
      ResultFormatter.day(decodeResult, Number(fields[1].substring(14, 16)));
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[1].substring(16, 20)));
      ResultFormatter.departureAirport(decodeResult, fields[1].substring(20, 24));
      ResultFormatter.arrivalAirport(decodeResult, fields[1].substring(24, 28));
      ResultFormatter.off(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[1].substring(28, 32)));
      ResultFormatter.unknown(decodeResult, fields[1].substring(32, 36));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[1].substring(36, 40)));
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`DEBUG: ${this.name}: Unknown variation.`);
      }
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_22_POS.ts
var Label_22_POS = class extends DecoderPlugin {
  name = "label-22-pos";
  qualifiers() {
    return {
      labels: ["22"],
      preambles: ["N", "S"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const fields = message.text.split(",");
    if (fields.length !== 11) {
      if (options.debug) {
        console.log(`DEBUG: ${this.name}: Unknown variation. Field count: ${fields.length}, content: ${fields.join(",")}`);
      }
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const latStr = fields[0].substring(1, 8);
    const lonStr = fields[0].substring(9);
    const lat = Number(latStr) / 1e4;
    const lon = Number(lonStr) / 1e4;
    ResultFormatter.position(decodeResult, {
      latitude: CoordinateUtils.getDirection(fields[0][0]) * lat,
      longitude: CoordinateUtils.getDirection(fields[0][8]) * lon
    });
    ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[2]));
    ResultFormatter.altitude(decodeResult, Number(fields[3]));
    ResultFormatter.unknownArr(decodeResult, [fields[1], ...fields.slice(4)]);
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_2P_FM3.ts
var Label_2P_FM3 = class extends DecoderPlugin {
  name = "label-2p-fm3";
  qualifiers() {
    return {
      labels: ["2P"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Flight Report";
    decodeResult.message = message;
    const parts = message.text.split(",");
    if (parts.length === 7) {
      const header = parts[0].split("FM3 ");
      if (header.length == 0) {
        ResultFormatter.unknown(decodeResult, message.text);
        decodeResult.decoded = false;
        decodeResult.decoder.decodeLevel = "none";
        return decodeResult;
      }
      if (header[0].length > 0) {
        ResultFormatter.unknown(decodeResult, header[0].substring(0, 4));
        ResultFormatter.flightNumber(decodeResult, header[0].substring(4));
      }
      console.log(header[1]);
      if (header[1].length === 4) {
        ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(header[1]));
      } else {
        ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(header[1]));
      }
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[1]));
      const lat = parts[2].replaceAll(" ", "");
      const lon = parts[3].replaceAll(" ", "");
      if (lat[0] === "N" || lat[0] === "S") {
        ResultFormatter.position(decodeResult, {
          latitude: CoordinateUtils.getDirection(lat[0]) * Number(lat.substring(1)),
          longitude: CoordinateUtils.getDirection(lon[0]) * Number(lon.substring(1))
        });
      } else {
        ResultFormatter.position(decodeResult, { latitude: Number(lat), longitude: Number(lon) });
      }
      ResultFormatter.altitude(decodeResult, Number(parts[4]));
      ResultFormatter.unknown(decodeResult, parts[5]);
      ResultFormatter.unknown(decodeResult, parts[6]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_2P_FM4.ts
var Label_2P_FM4 = class extends DecoderPlugin {
  name = "label-2p-fm4";
  qualifiers() {
    return {
      labels: ["2P"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Flight Report";
    decodeResult.message = message;
    const parts = message.text.split(",");
    if (parts.length === 10) {
      const header = parts[0].split("FM4");
      if (header.length == 0) {
        ResultFormatter.unknown(decodeResult, message.text);
        decodeResult.decoded = false;
        decodeResult.decoder.decodeLevel = "none";
        return decodeResult;
      }
      if (header[0].length > 0) {
        ResultFormatter.unknown(decodeResult, header[0].substring(0, 4));
        ResultFormatter.flightNumber(decodeResult, header[0].substring(4));
      }
      ResultFormatter.departureAirport(decodeResult, header[1]);
      ResultFormatter.arrivalAirport(decodeResult, parts[1]);
      ResultFormatter.day(decodeResult, Number(parts[2].substring(0, 2)));
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[2].substring(2)));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[3]));
      ResultFormatter.position(decodeResult, { latitude: Number(parts[4].replaceAll(" ", "")), longitude: Number(parts[5].replaceAll(" ", "")) });
      ResultFormatter.altitude(decodeResult, Number(parts[6]));
      ResultFormatter.heading(decodeResult, Number(parts[7]));
      ResultFormatter.unknown(decodeResult, parts[8]);
      ResultFormatter.unknown(decodeResult, parts[9]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_2P_FM5.ts
var Label_2P_FM5 = class extends DecoderPlugin {
  name = "label-2p-fm5";
  qualifiers() {
    return {
      labels: ["2P"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Flight Report";
    decodeResult.message = message;
    const parts = message.text.split(",");
    if (parts.length === 12) {
      const header = parts[0].split("FM5 ");
      if (header.length == 0) {
        ResultFormatter.unknown(decodeResult, message.text);
        decodeResult.decoded = false;
        decodeResult.decoder.decodeLevel = "none";
        return decodeResult;
      }
      ResultFormatter.departureAirport(decodeResult, header[1]);
      ResultFormatter.arrivalAirport(decodeResult, parts[1]);
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[2]));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(parts[3]));
      ResultFormatter.position(decodeResult, { latitude: Number(parts[4].replaceAll(" ", "")), longitude: Number(parts[5].replaceAll(" ", "")) });
      ResultFormatter.altitude(decodeResult, Number(parts[6]));
      ResultFormatter.unknown(decodeResult, parts[7]);
      ResultFormatter.unknown(decodeResult, parts[8]);
      ResultFormatter.unknown(decodeResult, parts[9]);
      ResultFormatter.flightNumber(decodeResult, parts[10].trim());
      ResultFormatter.unknown(decodeResult, parts[11]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_2P_POS.ts
var Label_2P_POS = class extends DecoderPlugin {
  name = "label-2p-pos";
  qualifiers() {
    return {
      labels: ["2P"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    const msg = message.text.replace(/\n|\r/g, "");
    const decoded = H1Helper.decodeH1Message(decodeResult, msg);
    decodeResult.decoded = decoded;
    decodeResult.decoder.decodeLevel = !decodeResult.remaining.text ? "full" : "partial";
    if (decodeResult.formatted.items.length === 0) {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_24_Slash.ts
var Label_24_Slash = class extends DecoderPlugin {
  name = "label-24-slash";
  qualifiers() {
    return {
      labels: ["24"],
      preambles: ["/"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const fields = message.text.split("/");
    if (fields.length == 10 && fields[0] == "" && fields[9] == "") {
      const mmddyy = fields[1].substring(4, 6) + fields[1].substring(2, 4) + fields[1].substring(0, 2);
      const hhmmss = fields[2] + "00";
      decodeResult.raw.message_timestamp = DateTimeUtils.convertDateTimeToEpoch(hhmmss, mmddyy);
      ResultFormatter.flightNumber(decodeResult, fields[3]);
      ResultFormatter.altitude(decodeResult, Number(fields[4]));
      const lat = fields[5];
      const lon = fields[6];
      const position = {
        latitude: (lat[0] === "N" ? 1 : -1) * Number(lat.substring(1)),
        longitude: (lon[0] === "E" ? 1 : -1) * Number(lon.substring(1))
      };
      ResultFormatter.position(decodeResult, position);
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[8]));
      ResultFormatter.unknown(decodeResult, fields[7]);
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`DEBUG: ${this.name}: Unknown variation. Field count: ${fields.length}. Message: ${message.text}`);
      }
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_30_Slash_EA.ts
var Label_30_Slash_EA = class extends DecoderPlugin {
  name = "label-30-slash-ea";
  qualifiers() {
    return {
      labels: ["30"],
      preambles: ["/EA"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "ETA Report";
    decodeResult.message = message;
    const results = message.text.split(/\n|\//).slice(1);
    if (results) {
      if (options.debug) {
        console.log(`Label 30 EA: results`);
        console.log(results);
      }
    }
    ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(results[0].substr(2, 4)));
    if (results[1].substring(0, 2) === "DS") {
      ResultFormatter.arrivalAirport(decodeResult, results[1].substring(2, 6));
      ResultFormatter.unknown(decodeResult, "/".concat(results[2]));
    } else {
      ResultFormatter.unknown(decodeResult, "/".concat(results[1], "/", results[2]));
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_44_ETA.ts
var Label_44_ETA = class extends DecoderPlugin {
  name = "label-44-eta";
  qualifiers() {
    return {
      labels: ["44"],
      preambles: ["00ETA01", "00ETA02", "00ETA03", "ETA01", "ETA02", "ETA03"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "ETA Report";
    decodeResult.message = message;
    const data = message.text.split(",");
    if (data.length >= 9) {
      if (options.debug) {
        console.log(`Label 44 ETA Report: groups`);
        console.log(data);
      }
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinatesDecimalMinutes(data[1]));
      ResultFormatter.altitude(decodeResult, 100 * Number(data[2]));
      ResultFormatter.departureAirport(decodeResult, data[3]);
      ResultFormatter.arrivalAirport(decodeResult, data[4]);
      ResultFormatter.month(decodeResult, Number(data[5].substring(0, 2)));
      ResultFormatter.day(decodeResult, Number(data[5].substring(2, 4)));
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[6]));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[7]));
      const fuel = Number(data[8]);
      if (!isNaN(fuel)) {
        ResultFormatter.remainingFuel(decodeResult, Number(fuel));
      }
      if (data.length > 9) {
        ResultFormatter.unknownArr(decodeResult, data.slice(9));
      }
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown 44 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_44_IN.ts
var Label_44_IN = class extends DecoderPlugin {
  name = "label-44-in";
  qualifiers() {
    return {
      labels: ["44"],
      preambles: ["00IN01", "00IN02", "00IN03", "IN01", "IN02", "IN03"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "In Air Report";
    decodeResult.message = message;
    const data = message.text.split(",");
    if (data.length >= 7) {
      if (options.debug) {
        console.log(`Label 44 In Air Report: groups`);
        console.log(data);
      }
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinatesDecimalMinutes(data[1]));
      ResultFormatter.departureAirport(decodeResult, data[2]);
      ResultFormatter.arrivalAirport(decodeResult, data[3]);
      ResultFormatter.month(decodeResult, Number(data[4].substring(0, 2)));
      ResultFormatter.day(decodeResult, Number(data[4].substring(2, 4)));
      ResultFormatter.in(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[5]));
      const fuel = Number(data[6]);
      if (!isNaN(fuel)) {
        ResultFormatter.remainingFuel(decodeResult, Number(fuel));
      }
      if (data.length > 7) {
        ResultFormatter.unknownArr(decodeResult, data.slice(7));
      }
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown 44 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_44_OFF.ts
var Label_44_OFF = class extends DecoderPlugin {
  name = "label-44-off";
  qualifiers() {
    return {
      labels: ["44"],
      preambles: ["00OFF01", "00OFF02", "00OFF03", "OFF01", "OFF02", "OFF03"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Off Runway Report";
    decodeResult.message = message;
    const data = message.text.split(",");
    if (data.length >= 8) {
      if (options.debug) {
        console.log(`Label 44 Off Runway Report: groups`);
        console.log(data);
      }
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinatesDecimalMinutes(data[1]));
      ResultFormatter.departureAirport(decodeResult, data[2]);
      ResultFormatter.arrivalAirport(decodeResult, data[3]);
      ResultFormatter.month(decodeResult, Number(data[4].substring(0, 2)));
      ResultFormatter.day(decodeResult, Number(data[4].substring(2, 4)));
      ResultFormatter.off(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[5]));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[6]));
      const fuel = Number(data[7]);
      if (!isNaN(fuel)) {
        ResultFormatter.remainingFuel(decodeResult, Number(fuel));
      }
      if (data.length > 8) {
        ResultFormatter.unknownArr(decodeResult, data.slice(8));
      }
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown 44 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_44_ON.ts
var Label_44_ON = class extends DecoderPlugin {
  name = "label-44-on";
  qualifiers() {
    return {
      labels: ["44"],
      preambles: ["00ON01", "00ON02", "00ON03", "ON01", "ON02", "ON03"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "On Runway Report";
    decodeResult.message = message;
    const data = message.text.split(",");
    if (data.length >= 7) {
      if (options.debug) {
        console.log(`Label 44 On Runway Report: groups`);
        console.log(data);
      }
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinatesDecimalMinutes(data[1]));
      ResultFormatter.departureAirport(decodeResult, data[2]);
      ResultFormatter.arrivalAirport(decodeResult, data[3]);
      ResultFormatter.month(decodeResult, Number(data[4].substring(0, 2)));
      ResultFormatter.day(decodeResult, Number(data[4].substring(2, 4)));
      ResultFormatter.on(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[5]));
      const fuel = Number(data[6]);
      if (!isNaN(fuel)) {
        ResultFormatter.remainingFuel(decodeResult, Number(fuel));
      }
      if (data.length > 7) {
        ResultFormatter.unknownArr(decodeResult, data.slice(7));
      }
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown 44 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_44_POS.ts
var Label_44_POS = class extends DecoderPlugin {
  name = "label-44-pos";
  qualifiers() {
    return {
      labels: ["44"],
      preambles: ["00POS01", "00POS02", "00POS03", "POS01", "POS02", "POS03"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const regex = /^.*,(?<unsplit_coords>.*),(?<flight_level_or_ground>.*),(?<departure_icao>.*),(?<arrival_icao>.*),(?<current_date>.*),(?<current_time>.*),(?<eta_time>.*),(?<fuel_in_tons>.*)$/;
    const results = message.text.match(regex);
    if (results?.groups) {
      if (options.debug) {
        console.log(`Label 44 Position Report: groups`);
        console.log(results.groups);
      }
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinatesDecimalMinutes(results.groups.unsplit_coords));
      const flight_level = results.groups.flight_level_or_ground == "GRD" || results.groups.flight_level_or_ground == "***" ? 0 : Number(results.groups.flight_level_or_ground);
      ResultFormatter.month(decodeResult, Number(results.groups.current_date.substring(0, 2)));
      ResultFormatter.day(decodeResult, Number(results.groups.current_date.substring(2, 4)));
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(results.groups.current_time + "00"));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(results.groups.eta_time + "00"));
      if (results.groups.fuel_in_tons != "***" && results.groups.fuel_in_tons != "****") {
        decodeResult.raw.fuel_in_tons = Number(results.groups.fuel_in_tons);
      }
      ResultFormatter.departureAirport(decodeResult, results.groups.departure_icao);
      ResultFormatter.arrivalAirport(decodeResult, results.groups.arrival_icao);
      ResultFormatter.altitude(decodeResult, flight_level * 100);
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_4A.ts
var Label_4A = class extends DecoderPlugin {
  name = "label-4a";
  qualifiers() {
    return {
      labels: ["4A"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Latest New Format";
    let text = message.text;
    if (text.match(/^M\d{2}A\w{6}/)) {
      ResultFormatter.flightNumber(decodeResult, message.text.substring(4, 10).replace(/^([A-Z]+)0*/g, "$1"));
      text = text.substring(10);
    }
    decodeResult.decoded = true;
    const fields = text.split(",");
    if (fields.length === 11) {
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[0]));
      ResultFormatter.tail(decodeResult, fields[2].replace(".", ""));
      if (fields[3])
        ResultFormatter.callsign(decodeResult, fields[3]);
      ResultFormatter.departureAirport(decodeResult, fields[4]);
      ResultFormatter.arrivalAirport(decodeResult, fields[5]);
      const alt = text.substring(48, 51);
      if (alt !== "") {
        ResultFormatter.altitude(decodeResult, Number(alt) * 100);
      }
      ResultFormatter.unknownArr(decodeResult, fields.slice(8));
    } else if (fields.length === 6) {
      if (fields[0].match(/^[NS]/)) {
        ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinates(fields[0].substring(0, 13)));
        let wp1 = {
          name: fields[0].substring(13).trim(),
          time: DateTimeUtils.convertHHMMSSToTod(fields[1].substring(0, 6)),
          timeFormat: "tod"
        };
        ResultFormatter.altitude(decodeResult, Number(fields[1].substring(6, 9)) * 100);
        let wp2 = {
          name: fields[1].substring(9).trim(),
          time: DateTimeUtils.convertHHMMSSToTod(fields[2]),
          timeFormat: "tod"
        };
        ResultFormatter.route(decodeResult, { waypoints: [wp1, wp2] });
        ResultFormatter.temperature(decodeResult, fields[3]);
        ResultFormatter.unknownArr(decodeResult, fields.slice(4));
      } else {
        ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[0]));
        ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[1]));
        ResultFormatter.unknown(decodeResult, fields[2]);
        ResultFormatter.altitude(decodeResult, Number(fields[3]));
        ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinates((fields[4] + fields[5]).replace(/[ \.]/g, "")));
      }
    } else {
      decodeResult.decoded = false;
      ResultFormatter.unknown(decodeResult, text);
    }
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_4A_01.ts
var Label_4A_01 = class extends DecoderPlugin {
  name = "label-4a-01";
  qualifiers() {
    return {
      labels: ["4A"],
      preambles: ["01"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Latest New Format";
    decodeResult.decoded = true;
    let rgx = message.text.match(/^01([A-Z]{2})([A-Z]{2})\s*(\w+)\/(\d{6})([A-Z]{4})([A-Z]{4})\r\n([+-]\s*\d+)(\d{3}\.\d)([+-]\s*\d+\.\d)/);
    if (rgx) {
      ResultFormatter.state_change(decodeResult, rgx[1], rgx[2]);
      ResultFormatter.callsign(decodeResult, rgx[3]);
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(rgx[4] + "00"));
      ResultFormatter.departureAirport(decodeResult, rgx[5]);
      ResultFormatter.arrivalAirport(decodeResult, rgx[6]);
      ResultFormatter.altitude(decodeResult, Number(rgx[7].replace(/ /g, "")));
      ResultFormatter.unknown(decodeResult, rgx[8]);
      ResultFormatter.temperature(decodeResult, rgx[9].replace(/ /g, ""));
    } else {
      decodeResult.decoded = false;
      ResultFormatter.unknown(decodeResult, message.text);
    }
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_4A_DIS.ts
var Label_4A_DIS = class extends DecoderPlugin {
  name = "label-4a-dis";
  qualifiers() {
    return {
      labels: ["4A"],
      preambles: ["DIS"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Latest New Format";
    decodeResult.decoded = true;
    const fields = message.text.split(",");
    ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[1].substring(2) + "00"));
    ResultFormatter.callsign(decodeResult, fields[2]);
    ResultFormatter.freetext(decodeResult, fields.slice(3).join(""));
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_4A_DOOR.ts
var Label_4A_DOOR = class extends DecoderPlugin {
  name = "label-4a-door";
  qualifiers() {
    return {
      labels: ["4A"],
      preambles: ["DOOR"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Latest New Format";
    decodeResult.decoded = true;
    const fields = message.text.split(" ");
    if (fields.length === 3) {
      ResultFormatter.door_event(decodeResult, fields[0].split("/")[1], fields[1]);
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[2] + "00"));
    } else {
      decodeResult.decoded = false;
      ResultFormatter.unknown(decodeResult, message.text);
    }
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_4A_Slash_01.ts
var Label_4A_Slash_01 = class extends DecoderPlugin {
  name = "label-4a-slash-01";
  qualifiers() {
    return {
      labels: ["4A"],
      preambles: ["/01"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Latest New Format";
    decodeResult.decoded = true;
    if (message.text.length === 5 && message.text.substring(0, 4) === "/01-") {
      ResultFormatter.unknown(decodeResult, message.text.substring(4));
    } else {
      decodeResult.decoded = false;
      ResultFormatter.unknown(decodeResult, message.text);
    }
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_4J_POS.ts
var Label_4J_POS = class extends DecoderPlugin {
  name = "label-4j-pos";
  qualifiers() {
    return {
      labels: ["4J"],
      preambles: ["POS/"]
    };
  }
  // copied from Label_H1.ts since i don't really want to have to have
  // something named like that decode more than 1 type
  // if we figure out a good name, i'll combine them
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    const msg = message.text.replace(/\n|\r/g, "");
    const decoded = H1Helper.decodeH1Message(decodeResult, msg);
    decodeResult.decoded = decoded;
    decodeResult.decoder.decodeLevel = !decodeResult.remaining.text ? "full" : "partial";
    if (decodeResult.formatted.items.length === 0) {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_4N.ts
var Label_4N = class extends DecoderPlugin {
  name = "label-4n";
  qualifiers() {
    return {
      labels: ["4N"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Airline Defined";
    let text = message.text;
    if (text.match(/^M\d{2}A\w{6}/)) {
      ResultFormatter.flightNumber(decodeResult, message.text.substring(4, 10).replace(/^([A-Z]+)0*/g, "$1"));
      text = text.substring(10);
    }
    decodeResult.decoded = true;
    const fields = text.split(",");
    if (text.length === 51) {
      decodeResult.raw.day = text.substring(0, 2);
      ResultFormatter.departureAirport(decodeResult, text.substring(8, 11));
      ResultFormatter.arrivalAirport(decodeResult, text.substring(13, 16));
      ResultFormatter.position(decodeResult, CoordinateUtils.decodeStringCoordinatesDecimalMinutes(text.substring(30, 45).replace(/^(.)0/, "$1")));
      ResultFormatter.altitude(decodeResult, Number(text.substring(48, 51)) * 100);
      ResultFormatter.unknownArr(decodeResult, [text.substring(2, 4), text.substring(19, 29)], " ");
    } else if (fields.length === 33) {
      decodeResult.raw.date = fields[3];
      if (fields[1] === "B") {
        ResultFormatter.position(decodeResult, { latitude: Number(fields[4]), longitude: Number(fields[5]) });
        ResultFormatter.altitude(decodeResult, Number(fields[6]));
      }
      ResultFormatter.departureAirport(decodeResult, fields[8]);
      ResultFormatter.arrivalAirport(decodeResult, fields[9]);
      ResultFormatter.alternateAirport(decodeResult, fields[10]);
      ResultFormatter.arrivalRunway(decodeResult, fields[11].split("/")[0]);
      if (fields[12].length > 1) {
        ResultFormatter.alternateRunway(decodeResult, fields[12].split("/")[0]);
      }
      ResultFormatter.checksum(decodeResult, fields[32]);
      ResultFormatter.unknownArr(decodeResult, [...fields.slice(1, 3), fields[7], ...fields.slice(13, 32)].filter((f) => f != ""));
    } else {
      decodeResult.decoded = false;
      ResultFormatter.unknown(decodeResult, text);
    }
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_4T_AGFSR.ts
var Label_4T_AGFSR = class extends DecoderPlugin {
  name = "label-4t-agfsr";
  qualifiers() {
    return {
      labels: ["4T"],
      preambles: ["AGFSR"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const data = message.text.substring(5).split("/");
    if (!message.text.startsWith("AGFSR") || data.length !== 20) {
      if (options.debug) {
        console.log(`Decoder: Unknown 4T message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.flightNumber(decodeResult, data[0].trim());
    ResultFormatter.departureDay(decodeResult, Number(data[1]));
    ResultFormatter.arrivalDay(decodeResult, Number(data[2]));
    ResultFormatter.departureAirport(decodeResult, data[3].substring(0, 3), "IATA");
    ResultFormatter.arrivalAirport(decodeResult, data[3].substring(3), "IATA");
    ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[4].substring(0, 4)));
    ResultFormatter.unknown(decodeResult, data[5], "/");
    const lat = data[6].substring(0, 7);
    const lon = data[6].substring(7, 15);
    ResultFormatter.position(decodeResult, {
      latitude: CoordinateUtils.getDirection(lat[6]) * Number(lat.substring(0, 2)) + Number(lat.substring(2, 6)) / 60,
      longitude: CoordinateUtils.getDirection(lon[7]) * Number(lon.substring(0, 3)) + Number(lon.substring(3, 7)) / 60
    });
    ResultFormatter.altitude(decodeResult, 100 * Number(data[7]));
    ResultFormatter.unknownArr(decodeResult, data.slice(8), "/");
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_58.ts
var Label_58 = class extends DecoderPlugin {
  name = "label-58";
  qualifiers() {
    return {
      labels: ["58"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const data = message.text.split("/");
    if (data.length === 8) {
      ResultFormatter.flightNumber(decodeResult, data[0]);
      ResultFormatter.day(decodeResult, Number(data[1]));
      ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(data[2]));
      const lat = data[3];
      const lon = data[4];
      ResultFormatter.position(decodeResult, {
        latitude: CoordinateUtils.getDirection(lat[0]) * Number(lat.substring(1)),
        longitude: CoordinateUtils.getDirection(lon[0]) * Number(lon.substring(1))
      });
      ResultFormatter.altitude(decodeResult, Number(data[5]));
      ResultFormatter.unknown(decodeResult, data[6], "/");
      ResultFormatter.unknown(decodeResult, data[7], "/");
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown 58 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_4T_ETA.ts
var Label_4T_ETA = class extends DecoderPlugin {
  name = "label-4t-eta";
  qualifiers() {
    return {
      labels: ["4T"],
      preambles: ["ETA"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "ETA Report";
    decodeResult.message = message;
    const data = message.text.substring(3).split("/");
    if (!message.text.startsWith("ETA") || data.length !== 3) {
      if (options.debug) {
        console.log(`Decoder: Unknown 4T message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.flightNumber(decodeResult, data[0].trim());
    ResultFormatter.departureDay(decodeResult, Number(data[1]));
    const etaData = data[2].split(" ");
    ResultFormatter.arrivalDay(decodeResult, Number(etaData[0]));
    ResultFormatter.arrivalAirport(decodeResult, etaData[1], "IATA");
    ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(etaData[2].substring(0, 4)));
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_80.ts
var Label_80 = class extends DecoderPlugin {
  name = "label-80";
  descriptions = {
    ALT: "Altitude",
    DWND: "Wind Direction",
    ETA: "Estimated Time of Arrival",
    FOB: "Fuel on Board",
    FL: "Flight Level",
    HDG: "Heading",
    MCH: "Aircraft Speed",
    NWYP: "Next Waypoint",
    POS: "Aircraft Position",
    SAT: "Static Air Temperature",
    SWND: "Wind Speed",
    TAS: "True Airspeed",
    WYP: "Waypoint"
  };
  qualifiers() {
    return {
      labels: ["80"],
      preambles: ["3N01 POSRPT"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Airline Defined Position Report";
    const parts = message.text.split("\n");
    let posRptRegex = /^3N01 POSRPT \d\d\d\d\/\d\d (?<orig>\w+)\/(?<dest>\w+) \.(?<tail>[\w-]+)(\/(?<agate>.+) (?<sta>\w+:\w+))*/;
    let results = parts[0].match(posRptRegex);
    if (!results?.groups) {
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    if (results && results.length > 0) {
      ResultFormatter.departureAirport(decodeResult, results.groups.orig);
      ResultFormatter.arrivalAirport(decodeResult, results.groups.dest);
      ResultFormatter.tail(decodeResult, results.groups.tail);
      if (results.groups.agate) {
        decodeResult.raw.arrival_gate = results.groups.agate;
        decodeResult.formatted.items.push({
          type: "arrival_gate",
          code: "ARG",
          label: "Arrival Gate",
          value: `${results.groups.agate}`
        });
        decodeResult.raw.scheduled_time_of_arrival = results.groups.sta;
        decodeResult.formatted.items.push({
          type: "scheduled_time_of_arrival",
          code: "STA",
          label: "Scheduled Time of Arrival",
          value: `${results.groups.sta}`
        });
      }
      posRptRegex = /\/(?<field>\w+)\s(?<value>[\w\+\-:\.]+)\s*/gi;
      const remainingParts = parts.slice(1);
      for (const part of remainingParts) {
        const matches = part.matchAll(posRptRegex);
        for (const match of matches) {
          switch (match.groups?.field) {
            case "ALT": {
              ResultFormatter.altitude(decodeResult, Number(match.groups.value));
              break;
            }
            case "DWND": {
              decodeResult.raw.wind_direction = Number(match.groups.value);
              decodeResult.formatted.items.push({
                type: "wind_direction",
                code: "DWND",
                label: this.descriptions[match.groups.field],
                value: decodeResult.raw.wind_direction
              });
              break;
            }
            case "FL": {
              const flight_level = Number(match.groups.value);
              ResultFormatter.altitude(decodeResult, flight_level * 100);
              break;
            }
            case "FOB": {
              const fob = Number(match.groups.value);
              if (!isNaN(fob)) {
                ResultFormatter.currentFuel(decodeResult, fob);
              }
              break;
            }
            case "HDG": {
              ResultFormatter.heading(decodeResult, Number(match.groups.value));
              break;
            }
            case "MCH": {
              decodeResult.raw.mach = Number(match.groups.value) / 1e3;
              decodeResult.formatted.items.push({
                type: "mach",
                code: "MCH",
                label: this.descriptions[match.groups.field],
                value: `${decodeResult.raw.mach} Mach`
              });
              break;
            }
            case "NWYP": {
              decodeResult.raw.next_waypoint = match.groups.value;
              decodeResult.formatted.items.push({
                type: "next_waypoint",
                code: "NWYP",
                label: this.descriptions[match.groups.field],
                value: decodeResult.raw.next_waypoint
              });
              break;
            }
            case "POS": {
              const posRegex = /^(?<latd>[NS])(?<lat>.+)(?<lngd>[EW])(?<lng>.+)/;
              const posResult = match.groups.value.match(posRegex);
              const lat = Number(posResult?.groups?.lat) * (posResult?.groups?.lngd === "S" ? -1 : 1);
              const lon = Number(posResult?.groups?.lng) * (posResult?.groups?.lngd === "W" ? -1 : 1);
              const position = {
                latitude: Number.isInteger(lat) ? lat / 1e3 : lat / 100,
                longitude: Number.isInteger(lon) ? lon / 1e3 : lon / 100
              };
              ResultFormatter.position(decodeResult, position);
              break;
            }
            case "SWND": {
              decodeResult.raw.wind_speed = Number(match.groups.value);
              decodeResult.formatted.items.push({
                type: "wind_speed",
                code: "SWND",
                label: this.descriptions[match.groups.field],
                value: decodeResult.raw.wind_speed
              });
              break;
            }
            default: {
              if (match.groups?.field != void 0) {
                const description = this.descriptions[match.groups.field] ? this.descriptions[match.groups.field] : "Unknown";
                decodeResult.formatted.items.push({
                  type: match.groups.field,
                  code: match.groups.field,
                  label: description || `Unknown (${match.groups.field})`,
                  value: `${match.groups.value}`
                });
              }
            }
          }
        }
      }
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_83.ts
var Label_83 = class extends DecoderPlugin {
  name = "label-83";
  qualifiers() {
    return {
      labels: ["83"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Airline Defined";
    let text = message.text;
    if (text.match(/^M\d{2}A\w{6}/)) {
      ResultFormatter.flightNumber(decodeResult, message.text.substring(4, 10).replace(/^([A-Z]+)0*/g, "$1"));
      text = text.substring(10);
    }
    decodeResult.decoded = true;
    if (text.substring(0, 10) === "4DH3 ETAT2") {
      const fields = text.split(/\s+/);
      if (fields[2].length > 5) {
        decodeResult.raw.day = fields[2].substring(5);
      }
      ResultFormatter.unknown(decodeResult, fields[2].substring(0, 4));
      const subfields = fields[3].split("/");
      ResultFormatter.departureAirport(decodeResult, subfields[0]);
      ResultFormatter.arrivalAirport(decodeResult, subfields[1]);
      ResultFormatter.tail(decodeResult, fields[4].replace(/\./g, ""));
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(fields[6] + "00"));
    } else if (text.substring(0, 5) === "001PR") {
      decodeResult.raw.day = text.substring(5, 7);
      const position = CoordinateUtils.decodeStringCoordinatesDecimalMinutes(text.substring(13, 28).replace(/\./g, ""));
      if (position) {
        ResultFormatter.position(decodeResult, position);
      }
      ResultFormatter.altitude(decodeResult, Number(text.substring(28, 33)));
      ResultFormatter.unknown(decodeResult, text.substring(33));
    } else {
      const fields = text.replace(/\s/g, "").split(",");
      if (fields.length === 9) {
        ResultFormatter.departureAirport(decodeResult, fields[0]);
        ResultFormatter.arrivalAirport(decodeResult, fields[1]);
        decodeResult.raw.day = fields[2].substring(0, 2);
        decodeResult.raw.time = fields[2].substring(2);
        ResultFormatter.position(
          decodeResult,
          {
            latitude: Number(fields[3].replace(/\s/g, "")),
            longitude: Number(fields[4].replace(/\s/g, ""))
          }
        );
        ResultFormatter.altitude(decodeResult, Number(fields[5]));
        ResultFormatter.groundspeed(decodeResult, Number(fields[6]));
        ResultFormatter.heading(decodeResult, Number(fields[7]));
        ResultFormatter.unknown(decodeResult, fields[8]);
      } else {
        decodeResult.decoded = false;
        ResultFormatter.unknown(decodeResult, message.text);
      }
    }
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_8E.ts
var Label_8E = class extends DecoderPlugin {
  name = "label-8e";
  qualifiers() {
    return {
      labels: ["8E"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "ETA Report";
    decodeResult.message = message;
    const regex = /^(?<arrival_icao>\w{4}),(?<arrival_eta>\d{4})$/;
    const results = message.text.match(regex);
    if (results?.groups) {
      if (options.debug) {
        console.log(`Label 8E ETA: groups`);
        console.log(results.groups);
      }
      ResultFormatter.eta(decodeResult, DateTimeUtils.convertHHMMSSToTod(results.groups.arrival_eta));
      ResultFormatter.arrivalAirport(decodeResult, results.groups.arrival_icao);
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_B6.ts
var Label_B6_Forwardslash = class extends DecoderPlugin {
  name = "label-b6-forwardslash";
  qualifiers() {
    return {
      labels: ["B6"],
      preambles: ["/"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "CPDLC Message";
    decodeResult.message = message;
    if (options.debug) {
      console.log("CPDLC: " + message);
    }
    return decodeResult;
  }
};

// lib/plugins/Label_ColonComma.ts
var Label_ColonComma = class extends DecoderPlugin {
  name = "label-colon-comma";
  qualifiers() {
    return {
      labels: [":;"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.raw.frequency = Number(message.text) / 1e3;
    decodeResult.formatted.description = "Aircraft Transceiver Frequency Change";
    decodeResult.formatted.items.push({
      type: "frequency",
      label: "Frequency",
      value: `${decodeResult.raw.frequency} MHz`,
      code: "FREQ"
    });
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_H1.ts
var Label_H1 = class extends DecoderPlugin {
  name = "label-h1";
  qualifiers() {
    return {
      labels: ["H1"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    const msg = message.text.replace(/\n|\r/g, "");
    const decoded = H1Helper.decodeH1Message(decodeResult, msg);
    decodeResult.decoded = decoded;
    decodeResult.decoder.decodeLevel = !decodeResult.remaining.text ? "full" : "partial";
    if (decodeResult.formatted.items.length === 0) {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_H1_FLR.ts
var Label_H1_FLR = class extends DecoderPlugin {
  name = "label-h1-flr";
  qualifiers() {
    return {
      labels: ["H1"],
      preambles: ["FLR", "#CFBFLR"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Fault Log Report";
    decodeResult.message = message;
    const parts = message.text.split("/FR");
    if (parts.length > 1) {
      const fields = parts[0].split("/");
      for (let i = 1; i < fields.length; i++) {
        const field = fields[i];
        ResultFormatter.unknown(decodeResult, field, "/");
      }
      const data = parts[1].substring(0, 20);
      const msg = parts[1].substring(20);
      const datetime = data.substring(0, 12);
      const date = datetime.substring(4, 6) + datetime.substring(2, 4) + datetime.substring(0, 2);
      ResultFormatter.unknown(decodeResult, data.substring(12), "/");
      decodeResult.raw.message_timestamp = DateTimeUtils.convertDateTimeToEpoch(datetime.substring(6), date);
      decodeResult.raw.fault_message = msg;
      decodeResult.formatted.items.push({
        type: "fault",
        code: "FR",
        label: "Fault Report",
        value: decodeResult.raw.fault_message
      });
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_H1_OHMA.ts
import * as zlib from "minizlib";
var Label_H1_OHMA = class extends DecoderPlugin {
  name = "label-h1-ohma";
  qualifiers() {
    return {
      labels: ["H1"],
      preambles: ["OHMA", "/RTNBOCR.OHMA", "#T1B/RTNBOCR.OHMA"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "OHMA Message";
    decodeResult.message = message;
    const data = message.text.split("OHMA")[1];
    try {
      const compressedBuffer = Buffer.from(data, "base64");
      const decompress = new zlib.Inflate({ windowBits: 15 });
      decompress.write(compressedBuffer);
      decompress.flush(zlib.constants.Z_SYNC_FLUSH);
      const result = decompress.read();
      const jsonText = result.toString();
      let formattedMsg;
      let jsonMessage;
      try {
        jsonMessage = JSON.parse(jsonText).message;
      } catch {
        jsonMessage = jsonText;
      }
      try {
        const ohmaMsg = JSON.parse(jsonMessage);
        formattedMsg = JSON.stringify(ohmaMsg, null, 2);
      } catch {
        formattedMsg = jsonMessage;
      }
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "full";
      decodeResult.raw.ohma = jsonText;
      decodeResult.formatted.items.push({
        type: "ohma",
        code: "OHMA",
        label: "OHMA Downlink",
        value: formattedMsg
      });
    } catch (e) {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 OHMA message: ${message.text}`, e);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_H1_Slash.ts
var Label_H1_Slash = class extends DecoderPlugin {
  name = "label-h1-slash";
  qualifiers() {
    return {
      labels: ["H1"],
      preambles: ["/"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const checksum = message.text.slice(-4);
    const data = message.text.slice(0, message.text.length - 4);
    const fields = data.split("/");
    if (fields[0] !== "") {
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    const headerData = fields[1].split(".");
    ResultFormatter.unknown(decodeResult, headerData[0]);
    if (headerData[1] === "POS" && fields[2].startsWith("TS") && fields[2].length > 15) {
      H1Helper.processPosition(decodeResult, fields[2].substring(15).split(","));
    } else if (headerData[1] === "POS") {
    } else if (headerData[1].startsWith("POS")) {
      H1Helper.processPosition(decodeResult, headerData[1].substring(3).split(","));
    } else {
      ResultFormatter.unknown(decodeResult, headerData[1], ".");
    }
    for (let i = 2; i < fields.length; i++) {
      const field = fields[i];
      if (field.startsWith("TS")) {
        H1Helper.processTS(decodeResult, field.substring(2, 15).split(","));
      } else if (field.startsWith("PS")) {
        H1Helper.processPS(decodeResult, field.substring(2).split(","));
      } else {
        ResultFormatter.unknown(decodeResult, field, "/");
      }
    }
    if (decodeResult.formatted.items.length === 0) {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.checksum(decodeResult, checksum);
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = !decodeResult.remaining.text ? "full" : "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_H1_StarPOS.ts
var Label_H1_StarPOS = class extends DecoderPlugin {
  name = "label-h1-star-pos";
  qualifiers() {
    return {
      labels: ["H1"],
      preambles: ["*POS"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Position Report";
    decodeResult.message = message;
    const msg = message.text;
    if (msg.length !== 43 || !msg.startsWith("*POS")) {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${msg}`);
      }
      ResultFormatter.unknown(decodeResult, msg);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
      return decodeResult;
    }
    ResultFormatter.month(decodeResult, Number(msg.substring(4, 6)));
    ResultFormatter.day(decodeResult, Number(msg.substring(6, 8)));
    ResultFormatter.time_of_day(decodeResult, DateTimeUtils.convertHHMMSSToTod(msg.substring(8, 12)));
    ResultFormatter.position(decodeResult, {
      // Deg Min, no sec
      latitude: CoordinateUtils.getDirection(msg.substring(12, 13)) * (Number(msg.substring(13, 15)) + Number(msg.substring(15, 17)) / 60),
      longitude: CoordinateUtils.getDirection(msg.substring(17, 18)) * (Number(msg.substring(18, 21)) + Number(msg.substring(21, 23)) / 60)
    });
    ResultFormatter.altitude(decodeResult, Number(msg.substring(23, 28)));
    ResultFormatter.unknown(decodeResult, msg.substring(28));
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_H1_WRN.ts
var Label_H1_WRN = class extends DecoderPlugin {
  name = "label-h1-wrn";
  qualifiers() {
    return {
      labels: ["H1"],
      preambles: ["WRN", "#CFBWRN"]
    };
  }
  decode(message, options = {}) {
    let decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "Warning Message";
    decodeResult.message = message;
    const parts = message.text.split("/WN");
    if (parts.length > 1) {
      const fields = parts[0].split("/");
      ResultFormatter.unknownArr(decodeResult, fields.slice(1), "/");
      const data = parts[1].substring(0, 20);
      const msg = parts[1].substring(20);
      const datetime = data.substring(0, 12);
      const date = datetime.substring(4, 6) + datetime.substring(2, 4) + datetime.substring(0, 2);
      ResultFormatter.unknown(decodeResult, data.substring(12), "/");
      decodeResult.raw.message_timestamp = DateTimeUtils.convertDateTimeToEpoch(datetime.substring(6), date);
      decodeResult.raw.warning_message = msg;
      decodeResult.formatted.items.push({
        type: "warning",
        code: "WRN",
        label: "Warning Message",
        value: decodeResult.raw.warning_message
      });
      decodeResult.decoded = true;
      decodeResult.decoder.decodeLevel = "partial";
    } else {
      if (options.debug) {
        console.log(`Decoder: Unknown H1 message: ${message.text}`);
      }
      ResultFormatter.unknown(decodeResult, message.text);
      decodeResult.decoded = false;
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_HX.ts
var Label_HX = class extends DecoderPlugin {
  name = "label-hx";
  qualifiers() {
    return {
      labels: ["HX"],
      preambles: ["RA FMT LOCATION", "RA FMT 43"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "Undelivered Uplink Report";
    const parts = message.text.split(" ");
    decodeResult.decoded = true;
    if (parts[2] === "LOCATION") {
      let latdir = parts[3].substring(0, 1);
      let latdeg = Number(parts[3].substring(1, 3));
      let latmin = Number(parts[3].substring(3, 7));
      let londir = parts[4].substring(0, 1);
      let londeg = Number(parts[4].substring(1, 4));
      let lonmin = Number(parts[4].substring(4, 8));
      let pos = {
        latitude: (latdeg + latmin / 60) * (latdir === "N" ? 1 : -1),
        longitude: (londeg + lonmin / 60) * (londir === "E" ? 1 : -1)
      };
      ResultFormatter.unknownArr(decodeResult, parts.slice(5), " ");
      ResultFormatter.position(decodeResult, pos);
    } else if (parts[2] === "43") {
      ResultFormatter.departureAirport(decodeResult, parts[3]);
      ResultFormatter.unknownArr(decodeResult, parts.slice(4), " ");
    } else {
      decodeResult.decoded = false;
    }
    if (decodeResult.decoded) {
      if (!decodeResult.remaining.text)
        decodeResult.decoder.decodeLevel = "full";
      else
        decodeResult.decoder.decodeLevel = "partial";
    } else {
      decodeResult.decoder.decodeLevel = "none";
    }
    return decodeResult;
  }
};

// lib/plugins/Label_SQ.ts
var Label_SQ = class extends DecoderPlugin {
  name = "label-sq";
  qualifiers() {
    return {
      labels: ["SQ"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.raw.preamble = message.text.substring(0, 4);
    decodeResult.raw.version = message.text.substring(1, 2);
    decodeResult.raw.network = message.text.substring(3, 4);
    if (decodeResult.raw.version === "2") {
      const regex = /0(\d)X(?<org>\w)(?<iata>\w\w\w)(?<icao>\w\w\w\w)(?<station>\d)(?<lat>\d+)(?<latd>[NS])(?<lng>\d+)(?<lngd>[EW])V(?<vfreq>\d+)\/.*/;
      const result = message.text.match(regex);
      if (result?.groups && result.length >= 8) {
        decodeResult.raw.groundStation = {
          number: result.groups.station,
          iataCode: result.groups.iata,
          icaoCode: result.groups.icao,
          coordinates: {
            latitude: Number(result.groups.lat) / 100 * (result.groups.latd === "S" ? -1 : 1),
            longitude: Number(result.groups.lng) / 100 * (result.groups.lngd === "W" ? -1 : 1)
          }
        };
        decodeResult.raw.vdlFrequency = Number(result.groups.vfreq) / 1e3;
      }
    }
    decodeResult.formatted.description = "Ground Station Squitter";
    var formattedNetwork = "Unknown";
    if (decodeResult.raw.network == "A") {
      formattedNetwork = "ARINC";
    } else if (decodeResult.raw.network == "S") {
      formattedNetwork = "SITA";
    }
    decodeResult.formatted.items = [
      {
        type: "network",
        code: "NETT",
        label: "Network",
        value: formattedNetwork
      },
      {
        type: "version",
        code: "VER",
        label: "Version",
        value: decodeResult.raw.version
      }
    ];
    if (decodeResult.raw.groundStation) {
      if (decodeResult.raw.groundStation.icaoCode && decodeResult.raw.groundStation.number) {
        decodeResult.formatted.items.push({
          type: "ground_station",
          code: "GNDSTN",
          label: "Ground Station",
          value: `${decodeResult.raw.groundStation.icaoCode}${decodeResult.raw.groundStation.number}`
        });
      }
      if (decodeResult.raw.groundStation.iataCode) {
        decodeResult.formatted.items.push({
          type: "iataCode",
          code: "IATA",
          label: "IATA",
          value: decodeResult.raw.groundStation.iataCode
        });
      }
      if (decodeResult.raw.groundStation.icaoCode) {
        decodeResult.formatted.items.push({
          type: "icaoCode",
          code: "ICAO",
          label: "ICAO",
          value: decodeResult.raw.groundStation.icaoCode
        });
      }
      if (decodeResult.raw.groundStation.coordinates.latitude) {
        decodeResult.formatted.items.push({
          type: "coordinates",
          code: "COORD",
          label: "Ground Station Location",
          value: `${decodeResult.raw.groundStation.coordinates.latitude}, ${decodeResult.raw.groundStation.coordinates.longitude}`
        });
      }
      if (decodeResult.raw.groundStation.airport) {
        decodeResult.formatted.items.push({
          type: "airport",
          code: "APT",
          label: "Airport",
          value: `${decodeResult.raw.groundStation.airport.name} (${decodeResult.raw.groundStation.airport.icao}) in ${decodeResult.raw.groundStation.airport.location}`
        });
      }
    }
    if (decodeResult.raw.vdlFrequency) {
      decodeResult.formatted.items.push({
        type: "vdlFrequency",
        code: "VDLFRQ",
        label: "VDL Frequency",
        value: `${decodeResult.raw.vdlFrequency} MHz`
      });
    }
    decodeResult.decoded = true;
    decodeResult.decoder.decodeLevel = "full";
    return decodeResult;
  }
};

// lib/plugins/Label_QR.ts
var Label_QR = class extends DecoderPlugin {
  name = "label-qr";
  qualifiers() {
    return {
      labels: ["QR"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "ON Report";
    ResultFormatter.departureAirport(decodeResult, message.text.substring(0, 4));
    ResultFormatter.arrivalAirport(decodeResult, message.text.substring(4, 8));
    ResultFormatter.on(decodeResult, DateTimeUtils.convertHHMMSSToTod(message.text.substring(8, 12)));
    ResultFormatter.unknown(decodeResult, message.text.substring(12));
    decodeResult.decoded = true;
    if (!decodeResult.remaining.text)
      decodeResult.decoder.decodeLevel = "full";
    else
      decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_QP.ts
var Label_QP = class extends DecoderPlugin {
  name = "label-qp";
  qualifiers() {
    return {
      labels: ["QP"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "OUT Report";
    ResultFormatter.departureAirport(decodeResult, message.text.substring(0, 4));
    ResultFormatter.arrivalAirport(decodeResult, message.text.substring(4, 8));
    ResultFormatter.out(decodeResult, DateTimeUtils.convertHHMMSSToTod(message.text.substring(8, 12)));
    ResultFormatter.unknown(decodeResult, message.text.substring(12));
    decodeResult.decoded = true;
    if (!decodeResult.remaining.text)
      decodeResult.decoder.decodeLevel = "full";
    else
      decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_QS.ts
var Label_QS = class extends DecoderPlugin {
  name = "label-qs";
  qualifiers() {
    return {
      labels: ["QS"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.formatted.description = "IN Report";
    ResultFormatter.departureAirport(decodeResult, message.text.substring(0, 4));
    ResultFormatter.arrivalAirport(decodeResult, message.text.substring(4, 8));
    ResultFormatter.in(decodeResult, DateTimeUtils.convertHHMMSSToTod(message.text.substring(8, 12)));
    ResultFormatter.unknown(decodeResult, message.text.substring(12));
    decodeResult.decoded = true;
    if (!decodeResult.remaining.text)
      decodeResult.decoder.decodeLevel = "full";
    else
      decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/plugins/Label_QQ.ts
var Label_QQ = class extends DecoderPlugin {
  name = "label-qq";
  qualifiers() {
    return {
      labels: ["QQ"]
    };
  }
  decode(message, options = {}) {
    const decodeResult = this.defaultResult();
    decodeResult.decoder.name = this.name;
    decodeResult.message = message;
    decodeResult.formatted.description = "OFF Report";
    ResultFormatter.departureAirport(decodeResult, message.text.substring(0, 4));
    ResultFormatter.arrivalAirport(decodeResult, message.text.substring(4, 8));
    if (message.text.substring(12, 19) === "\r\n001FE") {
      decodeResult.raw.day = message.text.substring(19, 21);
      ResultFormatter.off(decodeResult, DateTimeUtils.convertHHMMSSToTod(message.text.substring(21, 27)));
      let latdir = message.text.substring(27, 28);
      let latdeg = Number(message.text.substring(28, 30));
      let latmin = Number(message.text.substring(30, 34));
      let londir = message.text.substring(34, 35);
      let londeg = Number(message.text.substring(35, 38));
      let lonmin = Number(message.text.substring(38, 42));
      let pos = {
        latitude: (latdeg + latmin / 60) * (latdir === "N" ? 1 : -1),
        longitude: (londeg + lonmin / 60) * (londir === "E" ? 1 : -1)
      };
      ResultFormatter.unknown(decodeResult, message.text.substring(42, 45));
      ResultFormatter.position(decodeResult, pos);
      if (decodeResult.remaining.text !== "---") {
        ResultFormatter.groundspeed(decodeResult, Number(message.text.substring(45, 48)));
      } else {
        ResultFormatter.unknown(decodeResult, message.text.substring(45, 48));
      }
      ResultFormatter.unknown(decodeResult, message.text.substring(48));
    } else {
      ResultFormatter.off(decodeResult, DateTimeUtils.convertHHMMSSToTod(message.text.substring(8, 12) + "00"));
      ResultFormatter.unknown(decodeResult, message.text.substring(12));
    }
    decodeResult.decoded = true;
    if (!decodeResult.remaining.text)
      decodeResult.decoder.decodeLevel = "full";
    else
      decodeResult.decoder.decodeLevel = "partial";
    return decodeResult;
  }
};

// lib/utils/miam.ts
import * as Base85 from "base85";
import * as zlib2 from "minizlib";
var MIAMCoreV1CRCLength = 4;
var MIAMCoreV2CRCLength = 2;
var MIAMCoreUtils = class {
  static AppTypeToAppIdLenTable = {
    1: {
      [0 /* ACARS2Char */]: 2,
      [1 /* ACARS4Char */]: 4,
      [2 /* ACARS6Char */]: 6,
      [3 /* NonACARS6Char */]: 6
    },
    2: {
      [0 /* ACARS2Char */]: 2,
      [1 /* ACARS4Char */]: 4,
      [2 /* ACARS6Char */]: 6,
      [3 /* NonACARS6Char */]: 6
    }
  };
  static FidHandlerTable = {
    ["T" /* SingleTransfer */]: (txt) => {
      if (txt.length < 3) {
        return {
          decoded: false,
          error: "Raw MIAM message too short (" + txt.length + " < 3) "
        };
      }
      let bpad = txt[0];
      if ("0123-.".indexOf(bpad) === -1) {
        return {
          decoded: false,
          error: "Invalid body padding value: '" + bpad + "'"
        };
      }
      if ("0123".indexOf(txt[1]) === -1) {
        return {
          decoded: false,
          error: "Invalid header padding value: '" + txt[1] + "'"
        };
      }
      const hpad = parseInt(txt[1]);
      const delimIdx = txt.indexOf("|");
      if (delimIdx === -1) {
        return {
          decoded: false,
          error: "Raw MIAM message missing header-body delimiter"
        };
      }
      const rawHdr = txt.substring(2, delimIdx);
      if (rawHdr.length === 0) {
        return {
          decoded: false,
          error: "Empty MIAM message header"
        };
      }
      let hdr = Base85.decode("<~" + rawHdr + "~>", "ascii85");
      if (!hdr || hdr.length < hpad) {
        return {
          decoded: false,
          error: "Ascii85 decode failed for MIAM message header"
        };
      }
      let body = void 0;
      const rawBody = txt.substring(delimIdx + 1);
      if (rawBody.length > 0) {
        if ("0123".indexOf(bpad) >= 0) {
          const bpadValue = parseInt(bpad);
          body = Base85.decode("<~" + rawBody + "~>", "ascii85") || void 0;
          if (body && body.length >= bpadValue) {
            body = body.subarray(0, body.length - bpadValue);
          }
        } else if (bpad === "-") {
          body = Buffer.from(rawBody);
        }
      }
      hdr = hdr.subarray(0, hdr.length - hpad);
      const version = hdr.readUInt8(0) & 15;
      const pduType = hdr.readUInt8(0) >> 4 & 15;
      const versionPduHandler = this.VersionPduHandlerTable[version][pduType];
      if (versionPduHandler === void 0) {
        return {
          decoded: false,
          error: "Invalid version and PDU type combination: v=" + version + ", pdu=" + pduType
        };
      }
      return versionPduHandler(hdr, body);
    },
    ["F" /* FileTransferRequest */]: void 0,
    ["K" /* FileTransferAccept */]: void 0,
    ["S" /* FileSegment */]: void 0,
    ["A" /* FileTransferAbort */]: void 0,
    ["Y" /* XOFFIndication */]: void 0,
    ["X" /* XONIndication */]: void 0
  };
  static arincCrc16(buf, seed) {
    const crctable = [
      0,
      4129,
      8258,
      12387,
      16516,
      20645,
      24774,
      28903,
      33032,
      37161,
      41290,
      45419,
      49548,
      53677,
      57806,
      61935,
      4657,
      528,
      12915,
      8786,
      21173,
      17044,
      29431,
      25302,
      37689,
      33560,
      45947,
      41818,
      54205,
      50076,
      62463,
      58334,
      9314,
      13379,
      1056,
      5121,
      25830,
      29895,
      17572,
      21637,
      42346,
      46411,
      34088,
      38153,
      58862,
      62927,
      50604,
      54669,
      13907,
      9842,
      5649,
      1584,
      30423,
      26358,
      22165,
      18100,
      46939,
      42874,
      38681,
      34616,
      63455,
      59390,
      55197,
      51132,
      18628,
      22757,
      26758,
      30887,
      2112,
      6241,
      10242,
      14371,
      51660,
      55789,
      59790,
      63919,
      35144,
      39273,
      43274,
      47403,
      23285,
      19156,
      31415,
      27286,
      6769,
      2640,
      14899,
      10770,
      56317,
      52188,
      64447,
      60318,
      39801,
      35672,
      47931,
      43802,
      27814,
      31879,
      19684,
      23749,
      11298,
      15363,
      3168,
      7233,
      60846,
      64911,
      52716,
      56781,
      44330,
      48395,
      36200,
      40265,
      32407,
      28342,
      24277,
      20212,
      15891,
      11826,
      7761,
      3696,
      65439,
      61374,
      57309,
      53244,
      48923,
      44858,
      40793,
      36728,
      37256,
      33193,
      45514,
      41451,
      53516,
      49453,
      61774,
      57711,
      4224,
      161,
      12482,
      8419,
      20484,
      16421,
      28742,
      24679,
      33721,
      37784,
      41979,
      46042,
      49981,
      54044,
      58239,
      62302,
      689,
      4752,
      8947,
      13010,
      16949,
      21012,
      25207,
      29270,
      46570,
      42443,
      38312,
      34185,
      62830,
      58703,
      54572,
      50445,
      13538,
      9411,
      5280,
      1153,
      29798,
      25671,
      21540,
      17413,
      42971,
      47098,
      34713,
      38840,
      59231,
      63358,
      50973,
      55100,
      9939,
      14066,
      1681,
      5808,
      26199,
      30326,
      17941,
      22068,
      55628,
      51565,
      63758,
      59695,
      39368,
      35305,
      47498,
      43435,
      22596,
      18533,
      30726,
      26663,
      6336,
      2273,
      14466,
      10403,
      52093,
      56156,
      60223,
      64286,
      35833,
      39896,
      43963,
      48026,
      19061,
      23124,
      27191,
      31254,
      2801,
      6864,
      10931,
      14994,
      64814,
      60687,
      56684,
      52557,
      48554,
      44427,
      40424,
      36297,
      31782,
      27655,
      23652,
      19525,
      15522,
      11395,
      7392,
      3265,
      61215,
      65342,
      53085,
      57212,
      44955,
      49082,
      36825,
      40952,
      28183,
      32310,
      20053,
      24180,
      11923,
      16050,
      3793,
      7920
    ];
    let crc = (seed || 0) & 65535;
    for (let i = 0; i < buf.length; i++) {
      crc = (crc << 8 >>> 0 ^ crctable[(crc >>> 8 ^ buf.readUInt8(i)) >>> 0 & 255]) >>> 0;
    }
    return crc & 65535;
  }
  static arinc665Crc32(buf, seed) {
    const crctable = [
      0,
      79764919,
      159529838,
      222504665,
      319059676,
      398814059,
      445009330,
      507990021,
      638119352,
      583659535,
      797628118,
      726387553,
      890018660,
      835552979,
      1015980042,
      944750013,
      1276238704,
      1221641927,
      1167319070,
      1095957929,
      1595256236,
      1540665371,
      1452775106,
      1381403509,
      1780037320,
      1859660671,
      1671105958,
      1733955601,
      2031960084,
      2111593891,
      1889500026,
      1952343757,
      2552477408,
      2632100695,
      2443283854,
      2506133561,
      2334638140,
      2414271883,
      2191915858,
      2254759653,
      3190512472,
      3135915759,
      3081330742,
      3009969537,
      2905550212,
      2850959411,
      2762807018,
      2691435357,
      3560074640,
      3505614887,
      3719321342,
      3648080713,
      3342211916,
      3287746299,
      3467911202,
      3396681109,
      4063920168,
      4143685023,
      4223187782,
      4286162673,
      3779000052,
      3858754371,
      3904687514,
      3967668269,
      881225847,
      809987520,
      1023691545,
      969234094,
      662832811,
      591600412,
      771767749,
      717299826,
      311336399,
      374308984,
      453813921,
      533576470,
      25881363,
      88864420,
      134795389,
      214552010,
      2023205639,
      2086057648,
      1897238633,
      1976864222,
      1804852699,
      1867694188,
      1645340341,
      1724971778,
      1587496639,
      1516133128,
      1461550545,
      1406951526,
      1302016099,
      1230646740,
      1142491917,
      1087903418,
      2896545431,
      2825181984,
      2770861561,
      2716262478,
      3215044683,
      3143675388,
      3055782693,
      3001194130,
      2326604591,
      2389456536,
      2200899649,
      2280525302,
      2578013683,
      2640855108,
      2418763421,
      2498394922,
      3769900519,
      3832873040,
      3912640137,
      3992402750,
      4088425275,
      4151408268,
      4197601365,
      4277358050,
      3334271071,
      3263032808,
      3476998961,
      3422541446,
      3585640067,
      3514407732,
      3694837229,
      3640369242,
      1762451694,
      1842216281,
      1619975040,
      1682949687,
      2047383090,
      2127137669,
      1938468188,
      2001449195,
      1325665622,
      1271206113,
      1183200824,
      1111960463,
      1543535498,
      1489069629,
      1434599652,
      1363369299,
      622672798,
      568075817,
      748617968,
      677256519,
      907627842,
      853037301,
      1067152940,
      995781531,
      51762726,
      131386257,
      177728840,
      240578815,
      269590778,
      349224269,
      429104020,
      491947555,
      4046411278,
      4126034873,
      4172115296,
      4234965207,
      3794477266,
      3874110821,
      3953728444,
      4016571915,
      3609705398,
      3555108353,
      3735388376,
      3664026991,
      3290680682,
      3236090077,
      3449943556,
      3378572211,
      3174993278,
      3120533705,
      3032266256,
      2961025959,
      2923101090,
      2868635157,
      2813903052,
      2742672763,
      2604032198,
      2683796849,
      2461293480,
      2524268063,
      2284983834,
      2364738477,
      2175806836,
      2238787779,
      1569362073,
      1498123566,
      1409854455,
      1355396672,
      1317987909,
      1246755826,
      1192025387,
      1137557660,
      2072149281,
      2135122070,
      1912620623,
      1992383480,
      1753615357,
      1816598090,
      1627664531,
      1707420964,
      295390185,
      358241886,
      404320391,
      483945776,
      43990325,
      106832002,
      186451547,
      266083308,
      932423249,
      861060070,
      1041341759,
      986742920,
      613929101,
      542559546,
      756411363,
      701822548,
      3316196985,
      3244833742,
      3425377559,
      3370778784,
      3601682597,
      3530312978,
      3744426955,
      3689838204,
      3819031489,
      3881883254,
      3928223919,
      4007849240,
      4037393693,
      4100235434,
      4180117107,
      4259748804,
      2310601993,
      2373574846,
      2151335527,
      2231098320,
      2596047829,
      2659030626,
      2470359227,
      2550115596,
      2947551409,
      2876312838,
      2788305887,
      2733848168,
      3165939309,
      3094707162,
      3040238851,
      2985771188
    ];
    let crc = seed || 0;
    for (let i = 0; i < buf.length; i++) {
      crc = (crc << 8 >>> 0 ^ crctable[(crc >>> 24 ^ buf.readUInt8(i)) >>> 0]) >>> 0;
    }
    return crc;
  }
  static parse(txt) {
    const fidType = txt[0];
    const handler = this.FidHandlerTable[fidType];
    if (handler === void 0) {
      return {
        decoded: false,
        error: "Unsupported FID type: " + fidType
      };
    }
    return handler(txt.substring(1));
  }
  static corePduDataHandler(version, minHdrSize, crcLen, hdr, body) {
    if (hdr.length < minHdrSize) {
      return {
        decoded: false,
        error: "v" + version + " header size too short; expected >= " + minHdrSize + ", got " + hdr.length
      };
    }
    let pduSize = void 0;
    let pduCompression = 0;
    let pduEncoding = 0;
    let pduAppType = 0;
    let pduAppId = "";
    let pduCrc = 0;
    let pduData = void 0;
    let pduCrcIsOk = false;
    let pduIsComplete = true;
    let pduErrors = [];
    let tail = void 0;
    let msgNum = 0;
    let ackOptions = 0;
    if (version === 1) {
      pduSize = hdr.readUInt8(1) << 16 | hdr.readUInt8(2) << 8 | hdr.readUInt8(3);
      const msgSize = hdr.length + (body === void 0 ? 0 : body.length);
      if (pduSize > msgSize) {
        pduIsComplete = false;
        pduErrors.push("v1 PDU truncated: expecting " + pduSize + ", got " + msgSize);
      }
      hdr = hdr.subarray(4);
      tail = hdr.subarray(0, 7).toString("ascii");
      hdr = hdr.subarray(7);
    } else if (version === 2) {
      hdr = hdr.subarray(1);
    }
    msgNum = hdr.readUInt8(0) >> 1 & 127;
    ackOptions = hdr.readUInt8(0) & 1;
    hdr = hdr.subarray(1);
    pduCompression = (hdr.readUInt8(0) << 2 | hdr.readUInt8(1) >> 6 & 3) & 7;
    pduEncoding = hdr.readUInt8(1) >> 4 & 3;
    pduAppType = hdr.readUInt8(1) & 15;
    hdr = hdr.subarray(2);
    let appIdLen = this.AppTypeToAppIdLenTable[version][pduAppType];
    if (appIdLen === void 0) {
      if (version === 2 && (pduAppType & 8) !== 0 && pduAppType !== 13) {
        appIdLen = (pduAppType & 7) + 1;
      } else {
        return {
          decoded: false,
          error: "Invalid v" + version + " appType: " + pduAppType
        };
      }
    }
    const pduIsACARS = [
      0 /* ACARS2Char */,
      1 /* ACARS4Char */,
      2 /* ACARS6Char */,
      0 /* ACARS2Char */,
      1 /* ACARS4Char */,
      2 /* ACARS6Char */
    ].indexOf(pduAppType) >= 0;
    if (hdr.length < appIdLen + crcLen) {
      return {
        decoded: false,
        error: "Header too short for v" + version + " appType: " + pduAppType
      };
    }
    pduAppId = hdr.subarray(0, appIdLen).toString("ascii");
    hdr = hdr.subarray(appIdLen);
    if (crcLen === 4) {
      pduCrc = hdr.readUInt8(0) << 24 | hdr.readUInt8(1) << 16 | hdr.readUInt8(2) << 8 | hdr.readUInt8(3);
    } else if (crcLen === 2) {
      pduCrc = hdr.readUInt8(0) << 8 | hdr.readUInt8(1);
    }
    hdr = hdr.subarray(crcLen);
    if (body !== void 0 && body.length > 0) {
      if ([1 /* Deflate */, 1 /* Deflate */].indexOf(pduCompression) >= 0) {
        try {
          const decompress = new zlib2.InflateRaw({ windowBits: 15 });
          decompress.write(body);
          decompress.flush(zlib2.constants.Z_SYNC_FLUSH);
          pduData = decompress.read();
        } catch (e) {
          pduErrors.push("Inflation failed for body: " + e);
        }
      } else if ([0 /* None */, 0 /* None */].indexOf(pduCompression) >= 0) {
        pduData = body;
      } else {
        pduErrors.push("Unsupported v" + version + " compression type: " + pduCompression);
      }
      if (pduData !== void 0) {
        const crcAlgoHandlerByVersion = {
          1: (buf, seed) => {
            return ~this.arinc665Crc32(buf, seed);
          },
          2: this.arincCrc16
        };
        const crcAlgoHandler = crcAlgoHandlerByVersion[version];
        if (crcAlgoHandler === void 0) {
          return {
            decoded: false,
            errors: "No CRC handler for v" + version
          };
        }
        const crcCheck = crcAlgoHandler(pduData, 4294967295);
        if (crcCheck === pduCrc) {
          pduCrcIsOk = true;
        } else {
          pduErrors.push("Body failed CRC check: provided=" + pduCrc + ", generated=" + crcCheck);
        }
      }
    } else {
      pduCrcIsOk = true;
    }
    let pdu = {
      version,
      crc: pduCrc,
      crcOk: pduCrcIsOk,
      complete: pduIsComplete,
      compression: pduCompression,
      encoding: pduEncoding,
      msgNum,
      ackOptions
    };
    if (pduIsACARS) {
      const label = pduAppId.substring(0, 2);
      const sublabel = appIdLen >= 4 ? pduAppId.substring(2, 4) : void 0;
      const mfi = appIdLen >= 6 ? pduAppId.substring(4, 6) : void 0;
      pdu.acars = {
        ...tail ? { tail } : {},
        label,
        ...sublabel ? { sublabel } : {},
        ...mfi ? { mfi } : {},
        ...pduData ? { text: pduData.toString("ascii") } : {}
      };
    } else {
      pdu.non_acars = {
        appId: pduAppId,
        ...pduData ? { text: pduData.toString("ascii") } : {}
      };
    }
    return {
      decoded: true,
      message: {
        data: pdu
      }
    };
  }
  static VersionPduHandlerTable = {
    1: {
      [0 /* Data */]: (hdr, body) => {
        return this.corePduDataHandler(1, 20, MIAMCoreV1CRCLength, hdr, body);
      },
      [1 /* Ack */]: void 0,
      [2 /* Aloha */]: void 0,
      [3 /* AlohaReply */]: void 0
    },
    2: {
      [0 /* Data */]: (hdr, body) => {
        return this.corePduDataHandler(2, 7, MIAMCoreV2CRCLength, hdr, body);
      },
      [1 /* Ack */]: void 0,
      [2 /* Aloha */]: void 0,
      [3 /* AlohaReply */]: void 0
    }
  };
};

// lib/MessageDecoder.ts
var MessageDecoder = class {
  name;
  plugins;
  debug;
  constructor() {
    this.name = "acars-decoder-typescript";
    this.plugins = [];
    this.debug = false;
    this.registerPlugin(new Label_ColonComma(this));
    this.registerPlugin(new Label_5Z_Slash(this));
    this.registerPlugin(new Label_10_LDR(this));
    this.registerPlugin(new Label_10_POS(this));
    this.registerPlugin(new Label_10_Slash(this));
    this.registerPlugin(new Label_12_N_Space(this));
    this.registerPlugin(new Label_12_POS(this));
    this.registerPlugin(new Label_13Through18_Slash(this));
    this.registerPlugin(new Label_15(this));
    this.registerPlugin(new Label_15_FST(this));
    this.registerPlugin(new Label_16_N_Space(this));
    this.registerPlugin(new Label_16_POSA1(this));
    this.registerPlugin(new Label_16_TOD(this));
    this.registerPlugin(new Label_1J_2J_FTX(this));
    this.registerPlugin(new Label_1L_3Line(this));
    this.registerPlugin(new Label_1L_070(this));
    this.registerPlugin(new Label_1L_660(this));
    this.registerPlugin(new Label_1L_Slash(this));
    this.registerPlugin(new Label_20_POS(this));
    this.registerPlugin(new Label_21_POS(this));
    this.registerPlugin(new Label_22_OFF(this));
    this.registerPlugin(new Label_22_POS(this));
    this.registerPlugin(new Label_24_Slash(this));
    this.registerPlugin(new Label_2P_FM3(this));
    this.registerPlugin(new Label_2P_FM4(this));
    this.registerPlugin(new Label_2P_FM5(this));
    this.registerPlugin(new Label_2P_POS(this));
    this.registerPlugin(new Label_30_Slash_EA(this));
    this.registerPlugin(new Label_44_ETA(this));
    this.registerPlugin(new Label_44_IN(this));
    this.registerPlugin(new Label_44_OFF(this));
    this.registerPlugin(new Label_44_ON(this));
    this.registerPlugin(new Label_44_POS(this));
    this.registerPlugin(new Label_4A(this));
    this.registerPlugin(new Label_4A_01(this));
    this.registerPlugin(new Label_4A_DIS(this));
    this.registerPlugin(new Label_4A_DOOR(this));
    this.registerPlugin(new Label_4A_Slash_01(this));
    this.registerPlugin(new Label_4J_POS(this));
    this.registerPlugin(new Label_4N(this));
    this.registerPlugin(new Label_4T_AGFSR(this));
    this.registerPlugin(new Label_4T_ETA(this));
    this.registerPlugin(new Label_B6_Forwardslash(this));
    this.registerPlugin(new Label_H1_FLR(this));
    this.registerPlugin(new Label_H1_OHMA(this));
    this.registerPlugin(new Label_H1_WRN(this));
    this.registerPlugin(new Label_H1(this));
    this.registerPlugin(new Label_H1_Slash(this));
    this.registerPlugin(new Label_H1_StarPOS(this));
    this.registerPlugin(new Label_HX(this));
    this.registerPlugin(new Label_58(this));
    this.registerPlugin(new Label_80(this));
    this.registerPlugin(new Label_83(this));
    this.registerPlugin(new Label_8E(this));
    this.registerPlugin(new Label_1M_Slash(this));
    this.registerPlugin(new Label_SQ(this));
    this.registerPlugin(new Label_QP(this));
    this.registerPlugin(new Label_QQ(this));
    this.registerPlugin(new Label_QR(this));
    this.registerPlugin(new Label_QS(this));
  }
  registerPlugin(plugin) {
    const pluginInstance = plugin;
    this.plugins.push(plugin);
    return true;
  }
  decode(message, options = {}) {
    if (message.label === "MA") {
      const decodeResult = MIAMCoreUtils.parse(message.text);
      if (decodeResult.decoded && decodeResult.message.data !== void 0 && decodeResult.message.data.crcOk && decodeResult.message.data.complete && decodeResult.message.data.acars !== void 0) {
        message = {
          ...message,
          label: decodeResult.message.data.acars.label,
          ...decodeResult.message.data.acars.sublabel ? { sublabel: decodeResult.message.data.acars.sublabel } : {},
          ...decodeResult.message.data.acars.mfi ? { mfi: decodeResult.message.data.acars.mfi } : {},
          ...decodeResult.message.data.acars.text ? { text: decodeResult.message.data.acars.text } : {}
        };
      }
    }
    const usablePlugins = this.plugins.filter((plugin) => {
      const qualifiers = plugin.qualifiers();
      if (qualifiers.labels.includes(message.label)) {
        if (qualifiers.preambles && qualifiers.preambles.length > 0) {
          const matching = qualifiers.preambles.filter((preamble) => {
            return message.text.substring(0, preamble.length) === preamble;
          });
          return matching.length >= 1;
        } else {
          return true;
        }
      }
      return false;
    });
    if (options.debug) {
      console.log("Usable plugins");
      console.log(usablePlugins);
    }
    let result = {
      decoded: false,
      error: "No known decoder plugin for this message",
      decoder: {
        name: "none",
        type: "none",
        decodeLevel: "none"
      },
      message,
      remaining: {
        text: message.text
      },
      raw: {},
      formatted: {
        description: "Not Decoded",
        items: []
      }
    };
    for (let i = 0; i < usablePlugins.length; i++) {
      const plugin = usablePlugins[i];
      result = plugin.decode(message);
      if (result.decoded) {
        break;
      }
    }
    if (options.debug) {
      console.log("Result");
      console.log(result);
    }
    return result;
  }
  lookupAirportByIata(iata) {
    const airportsArray = [];
    const airport = airportsArray.filter((e) => e.iata === iata);
    return airport;
  }
};
export {
  IcaoDecoder,
  MessageDecoder
};
//# sourceMappingURL=index.mjs.map